webpackJsonp([1],Array(382).concat([
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_generate_app_vue__ = __webpack_require__(568);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4fae14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_generate_app_vue__ = __webpack_require__(696);
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_generate_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4fae14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_generate_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 383 */,
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-header'
});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var getDaysInMonth = __webpack_require__(394)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),
/* 390 */,
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function phonePer() {
	return '+51 927 476 997';
}

function phoneEcu() {
	return '33730500 - +593 998548169';
}
function created() {
	this.linkFace = 'https://www.facebook.com/Mi-bodega--107633674246248/?modal=admin_todo_tour';
	this.linkInst = 'https://www.instagram.com/mibodegapp';
	this.numberCoupon = '50';
}

function data() {
	return {
		linkFace: '',
		linkInst: '',
		numberCoupon: 0
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'new-footer',
	data: data,
	computed: {
		phonePer: phonePer,
		phoneEcu: phoneEcu
	},
	created: created,
	props: {
		gray: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ffe485_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(403);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70ffe485"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ffe485_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */,
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(384)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var differenceInCalendarMonths = __webpack_require__(412)
var compareAsc = __webpack_require__(386)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(389)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(134)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("5d57f7a4", content, true, {});

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".header[data-v-70ffe485]{background:#02979b;color:#fff;font-family:Lato;padding:40px 0 10px}.center[data-v-70ffe485]{text-align:center}.text[data-v-70ffe485]{font-weight:900}", "", {"version":3,"sources":["/opt/build/repo/src/components/pago/app-header.vue"],"names":[],"mappings":"AACA,yBACE,mBAAoB,AACpB,WAAe,AACf,iBAAoB,AACpB,mBAAuB,CACxB,AACD,yBACE,iBAAmB,CACpB,AACD,uBACE,eAAiB,CAClB","file":"app-header.vue","sourcesContent":["\n.header[data-v-70ffe485] {\n  background: #02979b;\n  color: #ffffff;\n  font-family: \"Lato\";\n  padding: 40px 0 10px 0;\n}\n.center[data-v-70ffe485] {\n  text-align: center;\n}\n.text[data-v-70ffe485] {\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"center mb-2"},[_c('button',{on:{"click":_vm.goToHome}},[_c('img',{attrs:{"src":(_vm.$S3 + "logo-mibodega-white.png"),"alt":"logo","height":"40"}})])]),_vm._v(" "),_c('p',{staticClass:"center text"},[_vm._v("Mi bodega, tu bodega.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(385)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(61)
var setISOYear = __webpack_require__(406)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var startOfISOYear = __webpack_require__(132)
var differenceInCalendarDays = __webpack_require__(133)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(385)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(388)

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(385)

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(388)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(61)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var differenceInCalendarDays = __webpack_require__(133)
var compareAsc = __webpack_require__(386)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__(405)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(396)
var parse = __webpack_require__(13)
var differenceInSeconds = __webpack_require__(398)
var differenceInMonths = __webpack_require__(397)
var enLocale = __webpack_require__(136)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__(423)

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(400)

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(132)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__(427)

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__(430)

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__(432)

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var getDaysInMonth = __webpack_require__(394)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_footer_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0170349e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_footer_vue__ = __webpack_require__(443);
function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0170349e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0170349e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(442);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("a2011bec", content, true, {});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".new-footer[data-v-0170349e]{font-family:Lato}.new-footer .footer-logo[data-v-0170349e]{background-color:#b1dc03;padding:50px 7%}.new-footer .footer-logo.gray[data-v-0170349e]{background-color:#fafafa}.new-footer .btn-footer[data-v-0170349e]{background-color:#02979b;border-radius:9px;color:#fff;display:inline-block;font-size:18px;text-align:center;padding:13px 0;text-decoration:none;width:100%}@media (max-width:936px){.new-footer .btn-footer[data-v-0170349e]{display:block;margin:auto;max-width:227px;width:100%}}.new-footer .footer-link[data-v-0170349e]{align-items:center;background-color:#fff;border-radius:50%;display:flex;height:54px;justify-content:center;text-align:center;width:54px}.new-footer .footer-link.gray[data-v-0170349e]{background-color:#b1dc03}.new-footer .wrapper-btn[data-v-0170349e]{align-self:center}.new-footer .wrapper-information[data-v-0170349e]{color:#02979b;padding:40px 7% 0}@media (min-width:1350px){.new-footer .wrapper-information[data-v-0170349e]{padding:40px 0 0}}.new-footer .title[data-v-0170349e]{font-size:24px}.new-footer .link-direction[data-v-0170349e]{color:#02979b;display:inline-block;text-decoration:none}.new-footer .wrapper-end[data-v-0170349e]{background:#02979b;color:#fff;padding:14px;text-align:center}.new-footer .link[data-v-0170349e]{color:#fff;text-decoration:none}.new-footer .logo[data-v-0170349e]{height:89px}@media (max-width:936px){.new-footer .logo[data-v-0170349e]{height:auto;width:100%}}.new-footer .logo-cel[data-v-0170349e]{height:312px}@media (max-width:936px){.new-footer .logo-cel[data-v-0170349e]{height:auto;width:100%}}@media (max-width:936px){.new-footer .btn-networks[data-v-0170349e]{margin-top:50px}}@media (max-width:936px){.new-footer .btn-networks.right[data-v-0170349e]{text-align:right;padding-right:14px}}@media (max-width:936px){.new-footer .btn-networks.left[data-v-0170349e]{padding-left:14px}}@media (max-width:936px){.new-footer .link-m-right[data-v-0170349e]{margin-left:auto}}.new-footer .order-1[data-v-0170349e]{order:1}.new-footer .order-2[data-v-0170349e]{order:2}.wrapper-text-medium[data-v-0170349e]{align-items:center;display:flex;padding:0 20px}.wrapper-text-medium p[data-v-0170349e]{color:#085f65;font-size:24px;font-weight:600}.dis-flex[data-v-0170349e]{display:flex}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/new-footer.vue"],"names":[],"mappings":"AACA,6BACE,gBAAoB,CACrB,AACD,0CACI,yBAA0B,AAC1B,eAAiB,CACpB,AACD,+CACM,wBAA0B,CAC/B,AACD,yCACI,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,eAAgB,AAChB,qBAAsB,AACtB,UAAY,CACf,AACD,yBACA,yCACQ,cAAe,AACf,YAAa,AACb,gBAAiB,AACjB,UAAY,CACnB,CACA,AACD,0CACI,mBAAoB,AACpB,sBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,YAAa,AACb,uBAAwB,AACxB,kBAAmB,AACnB,UAAY,CACf,AACD,+CACM,wBAA0B,CAC/B,AACD,0CACI,iBAAmB,CACtB,AACD,kDACI,cAAe,AACf,iBAAsB,CACzB,AACD,0BACA,kDACQ,gBAAoB,CAC3B,CACA,AACD,oCACI,cAAgB,CACnB,AACD,6CACI,cAAe,AACf,qBAAsB,AACtB,oBAAsB,CACzB,AACD,0CACI,mBAAoB,AACpB,WAAe,AACf,aAAc,AACd,iBAAmB,CACtB,AACD,mCACI,WAAe,AACf,oBAAsB,CACzB,AACD,mCACI,WAAa,CAChB,AACD,yBACA,mCACQ,YAAa,AACb,UAAY,CACnB,CACA,AACD,uCACI,YAAc,CACjB,AACD,yBACA,uCACQ,YAAa,AACb,UAAY,CACnB,CACA,AACD,yBACA,2CACM,eAAiB,CACtB,CACA,AACD,yBACA,iDACM,iBAAkB,AAClB,kBAAoB,CACzB,CACA,AACD,yBACA,gDACM,iBAAmB,CACxB,CACA,AACD,yBACA,2CACM,gBAAkB,CACvB,CACA,AACD,sCACI,OAAS,CACZ,AACD,sCACI,OAAS,CACZ,AACD,sCACE,mBAAoB,AACpB,aAAc,AACd,cAAgB,CACjB,AACD,wCACI,cAAe,AACf,eAAgB,AAChB,eAAiB,CACpB,AACD,2BACE,YAAc,CACf","file":"new-footer.vue","sourcesContent":["\n.new-footer[data-v-0170349e] {\n  font-family: \"Lato\";\n}\n.new-footer .footer-logo[data-v-0170349e] {\n    background-color: #b1dc03;\n    padding: 50px 7%;\n}\n.new-footer .footer-logo.gray[data-v-0170349e] {\n      background-color: #fafafa;\n}\n.new-footer .btn-footer[data-v-0170349e] {\n    background-color: #02979b;\n    border-radius: 9px;\n    color: #ffffff;\n    display: inline-block;\n    font-size: 18px;\n    text-align: center;\n    padding: 13px 0;\n    text-decoration: none;\n    width: 100%;\n}\n@media (max-width: 936px) {\n.new-footer .btn-footer[data-v-0170349e] {\n        display: block;\n        margin: auto;\n        max-width: 227px;\n        width: 100%;\n}\n}\n.new-footer .footer-link[data-v-0170349e] {\n    align-items: center;\n    background-color: #ffffff;\n    border-radius: 50%;\n    display: flex;\n    height: 54px;\n    justify-content: center;\n    text-align: center;\n    width: 54px;\n}\n.new-footer .footer-link.gray[data-v-0170349e] {\n      background-color: #b1dc03;\n}\n.new-footer .wrapper-btn[data-v-0170349e] {\n    align-self: center;\n}\n.new-footer .wrapper-information[data-v-0170349e] {\n    color: #02979b;\n    padding: 40px 7% 0 7%;\n}\n@media (min-width: 1350px) {\n.new-footer .wrapper-information[data-v-0170349e] {\n        padding: 40px 0 0 0;\n}\n}\n.new-footer .title[data-v-0170349e] {\n    font-size: 24px;\n}\n.new-footer .link-direction[data-v-0170349e] {\n    color: #02979b;\n    display: inline-block;\n    text-decoration: none;\n}\n.new-footer .wrapper-end[data-v-0170349e] {\n    background: #02979b;\n    color: #ffffff;\n    padding: 14px;\n    text-align: center;\n}\n.new-footer .link[data-v-0170349e] {\n    color: #ffffff;\n    text-decoration: none;\n}\n.new-footer .logo[data-v-0170349e] {\n    height: 89px;\n}\n@media (max-width: 936px) {\n.new-footer .logo[data-v-0170349e] {\n        height: auto;\n        width: 100%;\n}\n}\n.new-footer .logo-cel[data-v-0170349e] {\n    height: 312px;\n}\n@media (max-width: 936px) {\n.new-footer .logo-cel[data-v-0170349e] {\n        height: auto;\n        width: 100%;\n}\n}\n@media (max-width: 936px) {\n.new-footer .btn-networks[data-v-0170349e] {\n      margin-top: 50px;\n}\n}\n@media (max-width: 936px) {\n.new-footer .btn-networks.right[data-v-0170349e] {\n      text-align: right;\n      padding-right: 14px;\n}\n}\n@media (max-width: 936px) {\n.new-footer .btn-networks.left[data-v-0170349e] {\n      padding-left: 14px;\n}\n}\n@media (max-width: 936px) {\n.new-footer .link-m-right[data-v-0170349e] {\n      margin-left: auto;\n}\n}\n.new-footer .order-1[data-v-0170349e] {\n    order: 1;\n}\n.new-footer .order-2[data-v-0170349e] {\n    order: 2;\n}\n.wrapper-text-medium[data-v-0170349e] {\n  align-items: center;\n  display: flex;\n  padding: 0 20px;\n}\n.wrapper-text-medium p[data-v-0170349e] {\n    color: #085f65;\n    font-size: 24px;\n    font-weight: 600;\n}\n.dis-flex[data-v-0170349e] {\n  display: flex;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-footer"},[_c('v-layout',{staticClass:"footer-logo",class:{'gray': _vm.gray},attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',[_c('button',{on:{"click":_vm.goToHome}},[(_vm.gray)?_c('img',{staticClass:"logo",attrs:{"src":(_vm.$S3 + "logo-text-green.svg"),"alt":"logo"}}):_c('img',{staticClass:"logo",attrs:{"src":(_vm.$S3 + "logo-text.svg"),"alt":"logo"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-btn"},[_c('v-layout',{attrs:{"justify-end":"","wrap":""}},[(!_vm.gray)?_c('v-flex',{attrs:{"xs12":"","md5":"","mr-4":""}},[_c('a',{staticClass:"btn-footer bold",attrs:{"href":"#banner"}},[_vm._v("Solicita tu app")])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"btn-networks right",attrs:{"xs6":"","md2":""}},[_c('a',{staticClass:"footer-link link-m-right",class:{'gray': _vm.gray},attrs:{"href":_vm.linkFace,"target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "facebook-logo.png"),"alt":"facebook","height":"25"}})])]),_vm._v(" "),_c('v-flex',{staticClass:"btn-networks left",attrs:{"xs6":"","md2":""}},[_c('a',{staticClass:"footer-link",class:{'gray': _vm.gray},attrs:{"href":_vm.linkInst,"target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "instagram-logo.png"),"alt":"instagram","height":"25"}})])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"wrapper-information container",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{class:[_vm.isPeru ? 'order-1' : 'order-2'],attrs:{"xs12":""}},[_c('div',{staticClass:"mb-5"},[_c('p',{staticClass:"title bold"},[_vm._v("Perú")]),_vm._v(" "),_c('a',{staticClass:"bold link-direction mb-2",attrs:{"href":"https://goo.gl/maps/8vAGxHq1v49WAxj26","target":"_back"}},[_vm._v("Lima")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.phonePer)),_c('br'),_vm._v("Calle Independencia  106, Piso 10 "),_c('br'),_vm._v("Miraflores")])])]),_vm._v(" "),_c('v-flex',{class:[!_vm.isPeru ? 'order-1' : 'order-2'],attrs:{"xs12":""}},[_c('div',[_c('p',{staticClass:"title bold"},[_vm._v("Ecuador")]),_vm._v(" "),_c('a',{staticClass:"bold link-direction mb-2",attrs:{"href":"https://www.google.com/maps/search/Pinta+236+y+R%C3%A1bida.+Edif.+La+Pinta/@-0.1992127,-78.4896696,18z","target":"_blank"}},[_vm._v("Latacunga")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.phoneEcu)),_c('br'),_vm._v("AV. UNIDAD NACIONAL Y GABRIELA MISTRAL. EDIF. FENIX CORP. "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\tMatríz Centro Tecnológico Latacunga\n\t\t\t\t\t\t")])])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"dis-flex",attrs:{"xs12":"","md3":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"wrapper-text-medium",attrs:{"xs12":""}},[_c('p',{staticClass:"mb-0"},[_vm._v("Tenemos un regalo para los primeros "+_vm._s(_vm.numberCoupon)+" negocios validados.")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('img',{staticClass:"logo-cel",attrs:{"src":(_vm.$S3 + "phone-app-screen-footer-min.png"),"alt":"imagen celular"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__(384),
  addHours: __webpack_require__(404),
  addISOYears: __webpack_require__(405),
  addMilliseconds: __webpack_require__(385),
  addMinutes: __webpack_require__(407),
  addMonths: __webpack_require__(388),
  addQuarters: __webpack_require__(408),
  addSeconds: __webpack_require__(409),
  addWeeks: __webpack_require__(395),
  addYears: __webpack_require__(410),
  areRangesOverlapping: __webpack_require__(450),
  closestIndexTo: __webpack_require__(451),
  closestTo: __webpack_require__(452),
  compareAsc: __webpack_require__(386),
  compareDesc: __webpack_require__(396),
  differenceInCalendarDays: __webpack_require__(133),
  differenceInCalendarISOWeeks: __webpack_require__(453),
  differenceInCalendarISOYears: __webpack_require__(411),
  differenceInCalendarMonths: __webpack_require__(412),
  differenceInCalendarQuarters: __webpack_require__(454),
  differenceInCalendarWeeks: __webpack_require__(455),
  differenceInCalendarYears: __webpack_require__(414),
  differenceInDays: __webpack_require__(415),
  differenceInHours: __webpack_require__(456),
  differenceInISOYears: __webpack_require__(457),
  differenceInMilliseconds: __webpack_require__(389),
  differenceInMinutes: __webpack_require__(458),
  differenceInMonths: __webpack_require__(397),
  differenceInQuarters: __webpack_require__(459),
  differenceInSeconds: __webpack_require__(398),
  differenceInWeeks: __webpack_require__(460),
  differenceInYears: __webpack_require__(461),
  distanceInWords: __webpack_require__(417),
  distanceInWordsStrict: __webpack_require__(462),
  distanceInWordsToNow: __webpack_require__(463),
  eachDay: __webpack_require__(464),
  endOfDay: __webpack_require__(399),
  endOfHour: __webpack_require__(465),
  endOfISOWeek: __webpack_require__(466),
  endOfISOYear: __webpack_require__(467),
  endOfMinute: __webpack_require__(468),
  endOfMonth: __webpack_require__(419),
  endOfQuarter: __webpack_require__(469),
  endOfSecond: __webpack_require__(470),
  endOfToday: __webpack_require__(471),
  endOfTomorrow: __webpack_require__(472),
  endOfWeek: __webpack_require__(418),
  endOfYear: __webpack_require__(473),
  endOfYesterday: __webpack_require__(474),
  format: __webpack_require__(64),
  getDate: __webpack_require__(475),
  getDay: __webpack_require__(476),
  getDayOfYear: __webpack_require__(138),
  getDaysInMonth: __webpack_require__(394),
  getDaysInYear: __webpack_require__(477),
  getHours: __webpack_require__(478),
  getISODay: __webpack_require__(421),
  getISOWeek: __webpack_require__(135),
  getISOWeeksInYear: __webpack_require__(479),
  getISOYear: __webpack_require__(61),
  getMilliseconds: __webpack_require__(480),
  getMinutes: __webpack_require__(481),
  getMonth: __webpack_require__(482),
  getOverlappingDaysInRanges: __webpack_require__(483),
  getQuarter: __webpack_require__(413),
  getSeconds: __webpack_require__(484),
  getTime: __webpack_require__(485),
  getYear: __webpack_require__(486),
  isAfter: __webpack_require__(487),
  isBefore: __webpack_require__(488),
  isDate: __webpack_require__(65),
  isEqual: __webpack_require__(489),
  isFirstDayOfMonth: __webpack_require__(490),
  isFriday: __webpack_require__(491),
  isFuture: __webpack_require__(492),
  isLastDayOfMonth: __webpack_require__(493),
  isLeapYear: __webpack_require__(420),
  isMonday: __webpack_require__(494),
  isPast: __webpack_require__(495),
  isSameDay: __webpack_require__(496),
  isSameHour: __webpack_require__(422),
  isSameISOWeek: __webpack_require__(424),
  isSameISOYear: __webpack_require__(425),
  isSameMinute: __webpack_require__(426),
  isSameMonth: __webpack_require__(428),
  isSameQuarter: __webpack_require__(429),
  isSameSecond: __webpack_require__(431),
  isSameWeek: __webpack_require__(400),
  isSameYear: __webpack_require__(433),
  isSaturday: __webpack_require__(497),
  isSunday: __webpack_require__(498),
  isThisHour: __webpack_require__(499),
  isThisISOWeek: __webpack_require__(500),
  isThisISOYear: __webpack_require__(501),
  isThisMinute: __webpack_require__(502),
  isThisMonth: __webpack_require__(503),
  isThisQuarter: __webpack_require__(504),
  isThisSecond: __webpack_require__(505),
  isThisWeek: __webpack_require__(506),
  isThisYear: __webpack_require__(507),
  isThursday: __webpack_require__(508),
  isToday: __webpack_require__(509),
  isTomorrow: __webpack_require__(510),
  isTuesday: __webpack_require__(511),
  isValid: __webpack_require__(140),
  isWednesday: __webpack_require__(512),
  isWeekend: __webpack_require__(513),
  isWithinRange: __webpack_require__(514),
  isYesterday: __webpack_require__(515),
  lastDayOfISOWeek: __webpack_require__(516),
  lastDayOfISOYear: __webpack_require__(517),
  lastDayOfMonth: __webpack_require__(518),
  lastDayOfQuarter: __webpack_require__(519),
  lastDayOfWeek: __webpack_require__(434),
  lastDayOfYear: __webpack_require__(520),
  max: __webpack_require__(521),
  min: __webpack_require__(522),
  parse: __webpack_require__(13),
  setDate: __webpack_require__(523),
  setDay: __webpack_require__(524),
  setDayOfYear: __webpack_require__(525),
  setHours: __webpack_require__(526),
  setISODay: __webpack_require__(527),
  setISOWeek: __webpack_require__(528),
  setISOYear: __webpack_require__(406),
  setMilliseconds: __webpack_require__(529),
  setMinutes: __webpack_require__(530),
  setMonth: __webpack_require__(435),
  setQuarter: __webpack_require__(531),
  setSeconds: __webpack_require__(532),
  setYear: __webpack_require__(533),
  startOfDay: __webpack_require__(131),
  startOfHour: __webpack_require__(423),
  startOfISOWeek: __webpack_require__(41),
  startOfISOYear: __webpack_require__(132),
  startOfMinute: __webpack_require__(427),
  startOfMonth: __webpack_require__(534),
  startOfQuarter: __webpack_require__(430),
  startOfSecond: __webpack_require__(432),
  startOfToday: __webpack_require__(535),
  startOfTomorrow: __webpack_require__(536),
  startOfWeek: __webpack_require__(134),
  startOfYear: __webpack_require__(139),
  startOfYesterday: __webpack_require__(537),
  subDays: __webpack_require__(538),
  subHours: __webpack_require__(539),
  subISOYears: __webpack_require__(416),
  subMilliseconds: __webpack_require__(540),
  subMinutes: __webpack_require__(541),
  subMonths: __webpack_require__(542),
  subQuarters: __webpack_require__(543),
  subSeconds: __webpack_require__(544),
  subWeeks: __webpack_require__(545),
  subYears: __webpack_require__(546)
}


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__(41)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__(413)
var parse = __webpack_require__(13)

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(134)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(389)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var differenceInCalendarISOYears = __webpack_require__(411)
var compareAsc = __webpack_require__(386)
var subISOYears = __webpack_require__(416)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(389)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__(397)

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__(415)

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var differenceInCalendarYears = __webpack_require__(414)
var compareAsc = __webpack_require__(386)

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(396)
var parse = __webpack_require__(13)
var differenceInSeconds = __webpack_require__(398)
var enLocale = __webpack_require__(136)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__(417)

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__(418)

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(61)
var startOfISOWeek = __webpack_require__(41)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__(399)

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),
/* 472 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),
/* 474 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__(420)

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(132)
var addWeeks = __webpack_require__(395)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var endOfDay = __webpack_require__(399)
var endOfMonth = __webpack_require__(419)

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(131)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__(422)

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__(424)

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__(425)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__(426)

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__(428)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__(429)

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__(431)

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(400)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__(433)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(131)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(131)

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(131)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__(434)

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(61)
var startOfISOWeek = __webpack_require__(41)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var addDays = __webpack_require__(384)

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var addDays = __webpack_require__(384)
var getISODay = __webpack_require__(421)

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var getISOWeek = __webpack_require__(135)

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)
var setMonth = __webpack_require__(435)

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(13)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(131)

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(384)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__(404)

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(385)

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__(407)

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(388)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__(408)

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__(409)

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__(395)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__(410)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generate_app_banner_top__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generate_app_banner__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generate_app_section_generate_app__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_new_footer__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generate_app_section_benefits__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generate_app_section_question__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generate_app_section_header__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generate_app_section_invalid__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generate_app_section_expired__ = __webpack_require__(694);



var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var coupon, params, headers, response, endDateTime, startDateTime;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						coupon = 'LANZAR2020';
						params = {
							hour: '48'
						};
						headers = {
							Authorization: 'Bearer ' + this.token
						};
						_context.prev = 3;
						_context.next = 6;
						return this.$http.get('store-status/' + coupon, { params: params, headers: headers });

					case 6:
						response = _context.sent;

						this.configuration = response.data;
						endDateTime = new Date(response.endDate).getTime();
						startDateTime = new Date(response.startDate).getTime();

						this.timeEnd = endDateTime - startDateTime < 0;
						if (this.configuration.appConfig) {
							this.goTo('page-success-inscription', {
								params: {
									fullName: this.configuration.appConfig.name + ' ' + this.configuration.appConfig.surName
								}
							});
						}
						_context.next = 17;
						break;

					case 14:
						_context.prev = 14;
						_context.t0 = _context['catch'](3);

						if (_context.t0.data.statusCode === 401) {
							if (_context.t0.data.message === 'Bad token') {
								this.showInvalid = true;
							} else if (_context.t0.data.message === 'Expired') {
								this.showExpired = true;
							}
						}

					case 17:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 14]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var loadDepartaments = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var url, _ref3, response;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						url = this.isPeru ? 'province/public?countryCode=' + 'PER' : 'province/public';
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.get(url);

					case 4:
						_ref3 = _context2.sent;
						response = _ref3.data;

						this.departaments = response;
						_context2.next = 12;
						break;

					case 9:
						_context2.prev = 9;
						_context2.t0 = _context2['catch'](1);

						this.showGenericError();

					case 12:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 9]]);
	}));

	return function loadDepartaments() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











function created() {
	this.loadData();
	this.loadDepartaments();
}

function disabledRegisterApp() {
	return !this.configuration.flagAssigned || this.configuration.flagAppConfig || this.timeEnd;
}

function disabledPayment() {
	return !this.configuration.flagAssigned || this.configuration.flagPayment || this.timeEnd;
}

function getBannerValue(value) {
	this.bannerVisible = value;
}

function data() {
	return {
		bannerVisible: true,
		configuration: {
			color: {
				fifth: '#000000',
				fourth: '#ffffff',
				id: 1,
				primary: '#02979b',
				secondary: '#b1dc03',
				tertiary: '#085f65'
			}
		},
		timeEnd: false,
		departaments: [],
		showInvalid: false,
		showExpired: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-generate-app',
	created: created,
	computed: {
		disabledRegisterApp: disabledRegisterApp,
		disabledPayment: disabledPayment
	},
	data: data,
	components: {
		bannerTop: __WEBPACK_IMPORTED_MODULE_2__components_generate_app_banner_top__["a" /* default */],
		newFooter: __WEBPACK_IMPORTED_MODULE_5__components_home_new_footer__["a" /* default */],
		sectionGenerateApp: __WEBPACK_IMPORTED_MODULE_4__components_generate_app_section_generate_app__["a" /* default */],
		banner: __WEBPACK_IMPORTED_MODULE_3__components_generate_app_banner__["a" /* default */],
		sectionBenefits: __WEBPACK_IMPORTED_MODULE_6__components_generate_app_section_benefits__["a" /* default */],
		sectionQuestion: __WEBPACK_IMPORTED_MODULE_7__components_generate_app_section_question__["a" /* default */],
		sectionHeader: __WEBPACK_IMPORTED_MODULE_8__components_generate_app_section_header__["a" /* default */],
		sectionInvalid: __WEBPACK_IMPORTED_MODULE_9__components_generate_app_section_invalid__["a" /* default */],
		sectionExpired: __WEBPACK_IMPORTED_MODULE_10__components_generate_app_section_expired__["a" /* default */]
	},
	methods: {
		getBannerValue: getBannerValue,
		loadData: loadData,
		loadDepartaments: loadDepartaments
	},
	props: {
		token: String
	}
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generate_app_time_promotion__ = __webpack_require__(646);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function configuration(value) {
	var endDateMiliseconds = new Date(value.endDate).getTime();
	var todayMiliseconds = new Date().getTime();
	this.showTime = endDateMiliseconds - todayMiliseconds > 0;
}

function hiddenBanner() {
	this.showBanner = false;
	this.$emit('get-banner-value', this.showBanner);
}

function data() {
	return {
		showBanner: true,
		showTime: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'banner-top',
	components: {
		timePromotion: __WEBPACK_IMPORTED_MODULE_0__components_generate_app_time_promotion__["a" /* default */]
	},
	data: data,
	methods: {
		hiddenBanner: hiddenBanner
	},
	props: {
		configuration: {
			default: function _default() {},
			type: Object
		}
	},
	watch: {
		configuration: configuration
	}
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function hours() {
	return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.diffHours.toString()));
}

function minutes() {
	return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.diffMinutes.toString()));
}

function seconds() {
	return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.diffSeconds.toString()));
}

function created() {
	var _this = this;

	var fiveHours = 5 * 3600000;
	var endDateMiliseconds = new Date(this.endDate).getTime() - fiveHours;
	setInterval(function () {
		_this.todayMiliseconds = new Date().getTime();
		_this.diffHours = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["differenceInHours"])(endDateMiliseconds, _this.todayMiliseconds);
		var diffMinutes = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["differenceInMinutes"])(endDateMiliseconds, _this.todayMiliseconds);
		_this.diffMinutes = ((diffMinutes / 60 - _this.diffHours) * 60).toFixed(0);
		_this.diffMinutes = _this.diffMinutes.toString().length === 1 ? '0' + _this.diffMinutes : _this.diffMinutes;
		var diffSeconds = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns__["differenceInSeconds"])(endDateMiliseconds, _this.todayMiliseconds);
		_this.diffSeconds = Math.abs((((diffSeconds / 3600 - _this.diffHours) * 60 - _this.diffMinutes) * 60).toFixed(0));
		_this.diffSeconds = _this.diffSeconds.toString().length === 1 ? '0' + _this.diffSeconds : _this.diffSeconds;
	}, 1000);
}

function data() {
	return {
		diffHours: 0,
		diffMinutes: 0,
		diffSeconds: 0,
		todayMiliseconds: 0
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'time-maintance',
	data: data,
	computed: {
		hours: hours,
		minutes: minutes,
		seconds: seconds
	},
	created: created,
	props: {
		endDate: {
			default: '',
			type: String
		}
	}
});

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(649);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function goToHome() {
	this.goTo('page-home');
}

function data() {
	return {
		linkGooglePlay: 'https://play.google.com/store/apps/details?id=com.quipu.makipos.bodega',
		linkPayment: 'https://www.mercadopago.com.pe/checkout/v1/redirect?pref_id=547381162-58dab07e-3509-4b09-8fc3-90be611d9265',
		numberCoupon: '50'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'banner',
	data: data,
	methods: {
		goToHome: goToHome
	},
	props: {
		bannerVisible: {
			default: true,
			type: Boolean
		},
		disabledRegisterApp: {
			type: Boolean,
			default: false
		},
		disabledPayment: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generate_app_form_generate_app__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generate_app_section_phone__ = __webpack_require__(672);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function changeColor(item) {
	var _this = this;

	this.loadingColor = true;
	this.logo = this.logo.includes('/themes/') ? '/static/images/themes/theme-' + item.id + '-logo.svg' : this.logo;
	this.colorSelect = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
	setInterval(function () {
		_this.loadingColor = false;
	}, 1000);
}

function changeLogo(_ref) {
	var _this2 = this;

	var value = _ref.value,
	    loading = _ref.loading;

	this.loadingLogo = loading;
	this.logo = value;
	setInterval(function () {
		_this2.loadingLogo = false;
	}, 1500);
}

function changeBackground(_ref2) {
	var _this3 = this;

	var value = _ref2.value,
	    loading = _ref2.loading;

	this.loadingBackground = loading;
	this.background = value;
	setInterval(function () {
		_this3.loadingBackground = false;
	}, 1500);
}

function data() {
	return {
		background: '/static/images/simulator/background-default.png',
		colorSelect: {
			fifth: '#000000',
			fourth: '#ffffff',
			id: 1,
			primary: '#02979b',
			secondary: '#b1dc03',
			tertiary: '#085f65'
		},
		loadingBackground: false,
		loadingColor: false,
		loadingLogo: false,
		logo: '/static/images/themes/theme-1-logo.svg'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-generate-app',
	data: data,
	components: {
		formGenerateApp: __WEBPACK_IMPORTED_MODULE_1__components_generate_app_form_generate_app__["a" /* default */],
		sectionPhone: __WEBPACK_IMPORTED_MODULE_2__components_generate_app_section_phone__["a" /* default */]
	},
	methods: {
		changeBackground: changeBackground,
		changeColor: changeColor,
		changeLogo: changeLogo
	},
	props: {
		disabledRegisterApp: {
			type: Boolean,
			default: false
		},
		token: String,
		departaments: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	}
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_six_four__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_six_four___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_six_four__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helper__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generate_app_select_color__ = __webpack_require__(667);




var getFile = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(fileInfo, modelProp) {
		var labelLoading, newFile, words, lastItem, extension, _ref2, response;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						labelLoading = modelProp === 'logo' ? 'loadingLogo' : 'loadingBackground';
						newFile = {
							name: fileInfo.name.replace(/\s/g, '-'),
							image: fileInfo.sixFour
						};

						this[labelLoading] = true;
						_context.prev = 3;
						words = newFile.name.split('.');
						lastItem = words.length;
						extension = words[lastItem - 1];

						newFile.type = extension;

						if (!(this.allowedFiles.indexOf(extension) > -1)) {
							_context.next = 17;
							break;
						}

						_context.next = 11;
						return this.$http.post('image/one-upload', newFile);

					case 11:
						_ref2 = _context.sent;
						response = _ref2.data;

						this.model[modelProp] = response.data.url_image;
						this.$emit('change-' + modelProp, { value: this.model[modelProp], loading: this[labelLoading] });
						_context.next = 18;
						break;

					case 17:
						this.showNotification('Archivo no v\xE1lido, solo se permite ' + this.allowedFiles.join(','), 'warning');

					case 18:
						_context.next = 23;
						break;

					case 20:
						_context.prev = 20;
						_context.t0 = _context['catch'](3);

						if (_context.t0.data.statusCode === 413) {
							this.showGenericError('Tamaño máximo de imagen permitido es 1024Kb');
						} else {
							this.showGenericError();
						}

					case 23:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 20]]);
	}));

	return function getFile(_x, _x2) {
		return _ref.apply(this, arguments);
	};
}();

var generateApp = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var coupon, body, phoneStr, prefix, headers, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						coupon = 'LANZAR2020';
						body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model);

						if (!this.isPeru && body.phone.length === 10) {
							if (Number(body.phone[0]) === 0) {
								phoneStr = body.phone.toString();

								body.phone = phoneStr.slice(1, 10);
							}
						}
						delete body.color.id;
						prefix = this.countries.find(function (c) {
							return c.name === body.country;
						});

						body.phone = '' + prefix.phone + body.phone;
						body.flagNotifications = true;
						body.dataNotifications = {
							codeNotificationClient: 'CONFIRM-APP-EMAIL',
							codeNotificationCompany: 'CONF-APP-EMAIL',
							companyId: '35',
							sheetId: '1I6KjCkX53lLdV0KHZEM3Ys7siNYNGTr3O4VKuBVD3RA',
							emailCompany: 'mibodega@makipos.la',
							from: 'ventas@digitaldisruptor.pe',
							phoneCompany: '+51981286264',
							wtsTemplateCompany: 'WSP_APP_COMPANY_PER',
							wtsTemplateClient: 'WSP_APP_CLIENT_PER'
						};
						headers = {
							Authorization: 'Bearer ' + this.token
						};
						_context2.prev = 9;
						_context2.next = 12;
						return this.$http.post('store-app/' + coupon, body, { headers: headers });

					case 12:
						response = _context2.sent;

						if (Number(response.status) === 201) {
							this.goTo('page-success-inscription', {
								params: {
									fullName: body.name + ' ' + body.surName
								}
							});
						}
						_context2.next = 19;
						break;

					case 16:
						_context2.prev = 16;
						_context2.t0 = _context2['catch'](9);

						this.showGenericError('Ya expiró el tiempo o ya no es válido el token para la configuracion');

					case 19:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[9, 16]]);
	}));

	return function generateApp() {
		return _ref3.apply(this, arguments);
	};
}();

var rucValidate = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5) {
		var target = _ref5.target;

		var ruc, params, _ref6;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						ruc = target.value;

						if (!ruc) {
							_context3.next = 16;
							break;
						}

						params = { codeCountry: 'PER' };
						_context3.prev = 3;
						_context3.next = 6;
						return this.$httpApi.get('ruc/' + ruc, { params: params });

					case 6:
						_ref6 = _context3.sent;
						this.apiResponse = _ref6.data;

						this.rucInvalid = false;
						_context3.next = 14;
						break;

					case 11:
						_context3.prev = 11;
						_context3.t0 = _context3['catch'](3);

						if (_context3.t0.status === 405) {
							this.rucInvalid = true;
							this.showGenericError(_context3.t0.data.message);
						}

					case 14:
						_context3.next = 17;
						break;

					case 16:
						this.rucInvalid = true;

					case 17:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[3, 11]]);
	}));

	return function rucValidate(_x3) {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var debounce = __WEBPACK_IMPORTED_MODULE_4__shared_helper__["a" /* default */].debounce;


function created() {
	var items = 'Bebidas, Bodega, Cafetería, Carnicería, Calzados, Delivery, Deportes, Electricidad, Farmacia, Florería, Ferretería, Heladería, Juguetería, Librería, Otros, Panadería, Prendas de Vestir';
	this.activities = items.split(', ').map(function (i) {
		return { name: i };
	});
	this.model.country = this.isPeru ? 'Perú' : 'Ecuador';
	this.taxLabel =  true ? 'IGV' : 'IVA';
	this.currencySymbol =  true ? 'S/' : '$';
}

function changeColor(item) {
	var _this = this;

	this.loadingColor = true;
	this.$emit('change-color', item);
	setInterval(function () {
		_this.loadingColor = false;
	}, 1000);
}

function actionUploadImage(identifier) {
	this.$refs[identifier].click();
}

function disabledBtn() {
	return !this.model.business || !this.model.nameWarehouse || !this.model.password || !this.model.name || !this.model.email || !this.model.surName || !this.model.country || !this.model.phone || this.billingCheck && !this.model.ruc || this.model.ruc && this.rucInvalid;
}

function captionDepartament() {
	return this.isPeru ? 'Departamento' : 'Pronvicia';
}

function data() {
	return {
		activities: [],
		apiResponse: {},
		billingCheck: false,
		errorData: {},
		model: {
			address: '',
			business: null,
			nameWarehouse: null,
			password: null,
			logo: null,
			background: null,
			color: {
				fifth: '#000000',
				fourth: '#ffffff',
				id: 1,
				primary: '#02979b',
				secondary: '#b1dc03',
				tertiary: '#085f65'
			},
			name: null,
			email: null,
			surName: null,
			country: 'Perú',
			phone: null,
			ruc: null
		},
		allowedFiles: ['jpg', 'png', 'jpeg'],
		colors: [{
			id: 1,
			primary: '#02979b',
			secondary: '#b1dc03',
			tertiary: '#085f65',
			fourth: '#ffffff',
			fifth: '#000000'
		}, {
			id: 2,
			primary: '#014a99',
			secondary: '#ffec00',
			tertiary: '#003773',
			fourth: '#ffffff',
			fifth: '#000000'
		}, {
			id: 3,
			primary: '#f01d1d',
			secondary: '#2266aa',
			tertiary: '#cb0000',
			fourth: '#ffffff',
			fifth: '#000000'
		}, {
			id: 4,
			primary: '#00ab82',
			secondary: '#08b4cd',
			tertiary: '#268871',
			fourth: '#ffffff',
			fifth: '#000000'
		}, {
			id: 5,
			primary: '#000000',
			secondary: '#ede200',
			tertiary: '#2d2d2d',
			fourth: '#ffffff',
			fifth: '#000000'
		}],
		countries: [{
			id: 1,
			value: '+51',
			name: 'Perú',
			image: '/static/images/banners/peru.svg',
			phone: '51'
		}, {
			id: 2,
			value: '+593',
			name: 'Ecuador',
			image: '/static/images/banners/ecuador.svg',
			phone: '593'
		}],
		couponValue: 'LANZAR2020',
		costActual: '1800',
		costWithDiscount: '590',
		creditQuantity: '1500',
		loadingBackground: false,
		loadingColor: false,
		loadingLogo: false,
		taxLabel: '',
		currencySymbol: '',
		rucInvalid: true
	};
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'form-generate-app',
	data: data,
	components: {
		selectColor: __WEBPACK_IMPORTED_MODULE_5__components_generate_app_select_color__["a" /* default */],
		VueSixFour: __WEBPACK_IMPORTED_MODULE_3_vue_six_four___default.a
	},
	computed: {
		disabledBtn: disabledBtn,
		captionDepartament: captionDepartament
	},
	created: created,
	methods: {
		changeColor: changeColor,
		actionUploadImage: actionUploadImage,
		getFile: getFile,
		generateApp: generateApp,
		rucValidate: debounce(rucValidate)
	},
	props: {
		disabledRegisterApp: {
			type: Boolean,
			default: false
		},
		token: String,
		departaments: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	}
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function selectColor(item) {
	this.colorId = item.id;
	this.$emit('change-color', item);
}

function data() {
	return {
		colors: [{
			id: 1,
			colorOne: '#02979b',
			colorTwo: '#b1dc03',
			colorThree: '#ffffff',
			colorFour: '#4d4d4d'
		}, {
			id: 2,
			colorOne: '#007ec9',
			colorTwo: '#ffb700',
			colorThree: '#ffffff',
			colorFour: '#4d4d4d'
		}, {
			id: 3,
			colorOne: '#f01d1d',
			colorTwo: '#2266aa',
			colorThree: '#ffffff',
			colorFour: '#4d4d4d'
		}, {
			id: 4,
			colorOne: '#f26a00',
			colorTwo: '#02979b',
			colorThree: '#ffffff',
			colorFour: '#4d4d4d'
		}],
		colorId: 4
	};
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'select-color',
	data: data,
	methods: {
		selectColor: selectColor
	}
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function hiddenDialog() {
	this.dialog = false;
}

function showGallery() {
	this.dialog = true;
}

function showLoader() {
	return this.loadingColor || this.loadingLogo || this.loadingBackground;
}

function themeId(value) {
	this.slides = this.slides.map(function (slide, index) {
		var newSlide = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, slide);
		newSlide.image = index === 0 ? '/static/images/themes/theme-' + value + '-1.png' : '/static/images/themes/theme-' + value + '-' + (index + 1) + '.jpg';
		return newSlide;
	});
}

function data() {
	return {
		dialog: false,
		slides: [{
			id: 1,
			alt: 'simulador de aplicación',
			class: 'section-slider-slide-1',
			image: '/static/images/themes/theme-1-1.png'
		}, {
			id: 2,
			alt: 'simulador de aplicación',
			class: 'section-slider-slide-2',
			image: '/static/images/themes/theme-1-2.jpg'
		}, {
			id: 3,
			alt: 'simulador de aplicación',
			class: 'section-slider-slide-3',
			image: '/static/images/themes/theme-1-3.jpg'
		}, {
			id: 4,
			alt: 'simulador de aplicación',
			class: 'section-slider-slide-4',
			image: '/static/images/themes/theme-1-4.jpg'
		}],
		gallery: ['/static/images/gallery/customer-1.png', '/static/images/gallery/customer-2.png', '/static/images/gallery/customer-3.png', '/static/images/gallery/customer-4.png'],
		swiperOptions: {
			spaceBetween: 30,
			centeredSlides: true,
			autoplay: {
				delay: 10500,
				disableOnInteraction: true
			},
			pagination: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-phone',
	computed: {
		showLoader: showLoader
	},
	data: data,
	methods: {
		hiddenDialog: hiddenDialog,
		showGallery: showGallery
	},
	props: {
		background: String,
		colorSelect: {
			default: function _default() {},
			type: Object
		},
		loadingBackground: {
			default: false,
			type: Boolean
		},
		loadingColor: {
			default: false,
			type: Boolean
		},
		loadingLogo: {
			default: false,
			type: Boolean
		},
		logo: String,
		themeId: [Number, String]
	},
	watch: {
		themeId: themeId
	}
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function currencySymbol() {
	return this.isPeru ? 'S/' : '$';
}

function creditTotal() {
	return Number(this.creditQuantity) * Number(this.creditValue);
}

function hrefHere() {
	return this.isPeru ? 'https://registro.mibodega.net/' : 'https://registro-ec.mibodega.net/';
}

function data() {
	return {
		creditQuantity: '1500',
		creditValue: '0.2'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-benefits',
	computed: {
		creditTotal: creditTotal,
		currencySymbol: currencySymbol,
		hrefHere: hrefHere
	},
	data: data
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function centLabel() {
	return this.isPeru ? 'céntimos' : 'centavos';
}

function currencySymbol() {
	return this.isPeru ? 'S/' : '$';
}

function fiveOrders() {
	return this.creditValue / 5;
}

function hrefHere() {
	return this.isPeru ? 'https://registro.mibodega.net/' : 'https://registro-ec.mibodega.net/';
}

function data() {
	return {
		creditValue: '0.2',
		minValue: 20
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-question',
	computed: {
		centLabel: centLabel,
		currencySymbol: currencySymbol,
		fiveOrders: fiveOrders,
		hrefHere: hrefHere
	},
	data: data
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function created() {
	window.addEventListener('scroll', this.handleScroll);
}

function destroyed() {
	window.removeEventListener('scroll', this.handleScroll);
}

function handleScroll() {
	if (window.innerWidth < 934) {
		this.scrolled = window.scrollY > 750;
		this.scrollingOne = window.scrollY > 2600;
	} else {
		this.scrolled = window.scrollY > 400;
		this.scrollingOne = window.scrollY > 1350;
	}
}

function data() {
	return {
		scrolled: false,
		scrollingOne: false,
		linkGooglePlay: 'https://play.google.com/store/apps/details?id=com.quipu.makipos.bodega',
		linkPayment: 'https://www.mercadopago.com.pe/checkout/v1/redirect?pref_id=547381162-58dab07e-3509-4b09-8fc3-90be611d9265'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-header',
	created: created,
	data: data,
	destroyed: destroyed,
	methods: {
		handleScroll: handleScroll
	},
	props: {
		bannerVisible: {
			default: true,
			type: Boolean
		},
		disabledRegisterApp: {
			type: Boolean,
			default: false
		},
		disabledPayment: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pago_app_header__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generate_app_section_information__ = __webpack_require__(581);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-invalid',
	components: {
		headerPago: __WEBPACK_IMPORTED_MODULE_0__components_pago_app_header__["a" /* default */],
		sectionInformation: __WEBPACK_IMPORTED_MODULE_1__components_generate_app_section_information__["a" /* default */]
	}
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_information_vue__ = __webpack_require__(582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a96e38a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_information_vue__ = __webpack_require__(692);
function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a96e38a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a96e38a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function created() {
	var saleAdvisers = 'Vendedor 1 - 999999999'.split(', ').map(function (sa) {
		var saItems = sa.split('-');
		return {
			name: saItems[0],
			phone: '+' + saItems[1]
		};
	});
	this.contacts = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(saleAdvisers));
}

function wspContact(_ref) {
	var phone = _ref.phone;

	if (this.wspLink) {
		return 'https://api.whatsapp.com/send?phone=' + phone;
	}
	return 'https://web.whatsapp.com/send?phone=' + phone;
}

function wspLink() {
	var reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	return reg.test(navigator.userAgent);
}

function data() {
	return {
		contacts: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-information',
	computed: {
		wspLink: wspLink
	},
	created: created,
	data: data,
	methods: {
		wspContact: wspContact
	},
	props: {
		message: String,
		messageDown: String,
		invalid: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pago_app_header__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generate_app_section_information__ = __webpack_require__(581);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'section-expired',
	components: {
		sectionInformation: __WEBPACK_IMPORTED_MODULE_1__components_generate_app_section_information__["a" /* default */],
		headerPago: __WEBPACK_IMPORTED_MODULE_0__components_pago_app_header__["a" /* default */]
	}
});

/***/ }),
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_top_vue__ = __webpack_require__(569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bcbec9b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_top_vue__ = __webpack_require__(654);
function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bcbec9b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bcbec9b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(645);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("76241d6e", content, true, {});

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".banner-top[data-v-3bcbec9b]{background:#e6c60c;color:#fff;font-size:16px;font-weight:600;height:68px;padding:10px 7%;position:fixed;width:100%;z-index:9999}.banner-top .information[data-v-3bcbec9b]{font-size:22px}@media (max-width:830px){.banner-top .information[data-v-3bcbec9b]{font-size:15px}}.banner-top .time[data-v-3bcbec9b]{font-size:32px}@media (max-width:830px){.banner-top .time[data-v-3bcbec9b]{font-size:20px}}.banner-top .wrapper-information[data-v-3bcbec9b]{height:100%;border-right:1px solid #fff;padding-right:22px;text-align:right}@media (max-width:830px){.banner-top .wrapper-information[data-v-3bcbec9b]{border-right:none;padding-right:0;text-align:center}}.banner-top .wrapper-time[data-v-3bcbec9b]{padding-left:22px}@media (max-width:830px){.banner-top .wrapper-time[data-v-3bcbec9b]{padding-left:0}}.banner-top .text[data-v-3bcbec9b]{margin-right:16px;padding-top:13px}@media (max-width:830px){.banner-top .text[data-v-3bcbec9b]{margin-right:0}}.banner-top .pt-8[data-v-3bcbec9b]{padding-top:8px}.banner-top .group[data-v-3bcbec9b]{display:flex}@media (max-width:830px){.banner-top .group[data-v-3bcbec9b]{display:block;text-align:center}}@media (max-width:830px){.banner-top[data-v-3bcbec9b]{height:auto;padding:4px}}.btn-close[data-v-3bcbec9b]{bottom:0;margin:auto;position:absolute;right:17px;top:0;z-index:1}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/banner-top.vue"],"names":[],"mappings":"AACA,6BACE,mBAAoB,AACpB,WAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,gBAAiB,AACjB,eAAgB,AAChB,WAAY,AACZ,YAAc,CACf,AACD,0CACI,cAAgB,CACnB,AACD,yBACA,0CACQ,cAAgB,CACvB,CACA,AACD,mCACI,cAAgB,CACnB,AACD,yBACA,mCACQ,cAAgB,CACvB,CACA,AACD,kDACI,YAAa,AACb,4BAAgC,AAChC,mBAAoB,AACpB,gBAAkB,CACrB,AACD,yBACA,kDACQ,kBAAmB,AACnB,gBAAiB,AACjB,iBAAmB,CAC1B,CACA,AACD,2CACI,iBAAmB,CACtB,AACD,yBACA,2CACQ,cAAgB,CACvB,CACA,AACD,mCACI,kBAAmB,AACnB,gBAAkB,CACrB,AACD,yBACA,mCACQ,cAAgB,CACvB,CACA,AACD,mCACI,eAAiB,CACpB,AACD,oCACI,YAAc,CACjB,AACD,yBACA,oCACQ,cAAe,AACf,iBAAmB,CAC1B,CACA,AACD,yBACA,6BACM,YAAa,AACb,WAAa,CAClB,CACA,AACD,4BACE,SAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,MAAS,AACT,SAAW,CACZ","file":"banner-top.vue","sourcesContent":["\n.banner-top[data-v-3bcbec9b] {\n  background: #e6c60c;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  height: 68px;\n  padding: 10px 7%;\n  position: fixed;\n  width: 100%;\n  z-index: 9999;\n}\n.banner-top .information[data-v-3bcbec9b] {\n    font-size: 22px;\n}\n@media (max-width: 830px) {\n.banner-top .information[data-v-3bcbec9b] {\n        font-size: 15px;\n}\n}\n.banner-top .time[data-v-3bcbec9b] {\n    font-size: 32px;\n}\n@media (max-width: 830px) {\n.banner-top .time[data-v-3bcbec9b] {\n        font-size: 20px;\n}\n}\n.banner-top .wrapper-information[data-v-3bcbec9b] {\n    height: 100%;\n    border-right: 1px solid #ffffff;\n    padding-right: 22px;\n    text-align: right;\n}\n@media (max-width: 830px) {\n.banner-top .wrapper-information[data-v-3bcbec9b] {\n        border-right: none;\n        padding-right: 0;\n        text-align: center;\n}\n}\n.banner-top .wrapper-time[data-v-3bcbec9b] {\n    padding-left: 22px;\n}\n@media (max-width: 830px) {\n.banner-top .wrapper-time[data-v-3bcbec9b] {\n        padding-left: 0;\n}\n}\n.banner-top .text[data-v-3bcbec9b] {\n    margin-right: 16px;\n    padding-top: 13px;\n}\n@media (max-width: 830px) {\n.banner-top .text[data-v-3bcbec9b] {\n        margin-right: 0;\n}\n}\n.banner-top .pt-8[data-v-3bcbec9b] {\n    padding-top: 8px;\n}\n.banner-top .group[data-v-3bcbec9b] {\n    display: flex;\n}\n@media (max-width: 830px) {\n.banner-top .group[data-v-3bcbec9b] {\n        display: block;\n        text-align: center;\n}\n}\n@media (max-width: 830px) {\n.banner-top[data-v-3bcbec9b] {\n      height: auto;\n      padding: 4px;\n}\n}\n.btn-close[data-v-3bcbec9b] {\n  bottom: 0px;\n  margin: auto;\n  position: absolute;\n  right: 17px;\n  top: 0px;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_promotion_vue__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311b4222_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_promotion_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-311b4222"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_promotion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311b4222_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_promotion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("62b1be26", content, true, {});

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".wrapper-time[data-v-311b4222]{display:flex}@media (max-width:830px){.wrapper-time[data-v-311b4222]{justify-content:center}}.wrapper-text[data-v-311b4222]{display:flex;font-size:32px}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/time-promotion.vue"],"names":[],"mappings":"AACA,+BACE,YAAc,CACf,AACD,yBACA,+BACM,sBAAwB,CAC7B,CACA,AACD,+BACE,aAAc,AACd,cAAgB,CACjB","file":"time-promotion.vue","sourcesContent":["\n.wrapper-time[data-v-311b4222] {\n  display: flex;\n}\n@media (max-width: 830px) {\n.wrapper-time[data-v-311b4222] {\n      justify-content: center;\n}\n}\n.wrapper-text[data-v-311b4222] {\n  display: flex;\n  font-size: 32px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(650), __esModule: true };

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42);
__webpack_require__(651);
module.exports = __webpack_require__(10).Array.from;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(27);
var $export = __webpack_require__(22);
var toObject = __webpack_require__(68);
var call = __webpack_require__(141);
var isArrayIter = __webpack_require__(142);
var toLength = __webpack_require__(67);
var createProperty = __webpack_require__(652);
var getIterFn = __webpack_require__(69);

$export($export.S + $export.F * !__webpack_require__(143)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(28);
var createDesc = __webpack_require__(66);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper-time"},[_c('div',{staticClass:"wrapper-text"},[_vm._l((_vm.hours),function(hour,indexHour){return _c('div',{key:indexHour},[_vm._v("\n\t\t\t\t"+_vm._s(hour)+"\n\t\t\t")])}),_vm._v(" "),_c('span',[_vm._v(":")])],2),_vm._v(" "),_c('div',{staticClass:"wrapper-text"},[_vm._l((_vm.minutes),function(minute,indexMinute){return _c('div',{key:indexMinute},[_vm._v("\n\t\t\t\t"+_vm._s(minute)+"\n\t\t\t")])}),_vm._v(" "),_c('span',[_vm._v(":")])],2),_vm._v(" "),_c('div',{staticClass:"wrapper-text"},_vm._l((_vm.seconds),function(second,indexSecond){return _c('div',{key:indexSecond},[_vm._v("\n\t\t\t\t"+_vm._s(second)+"\n\t\t\t")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBanner)?_c('div',{staticClass:"banner-top"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"wrapper-information pt-8",attrs:{"xs12":"","md7":""}},[_c('p',{staticClass:"mb-0 information"},[_vm._v("Esta promoción tiene una duración de 48 horas")])]),_vm._v(" "),_c('v-flex',{staticClass:"wrapper-time",attrs:{"xs12":"","md5":""}},[(_vm.showTime)?_c('div',{staticClass:"group"},[_c('p',{staticClass:"mb-0 text"},[_vm._v("Tiempo restante:")]),_vm._v(" "),_c('time-promotion',{attrs:{"end-date":_vm.configuration.endDate}})],1):_c('div',{staticClass:"group"},[_c('p',{staticClass:"mb-0 text"},[_vm._v("LA PROMOCIÓN YA CADUCO")])])]),_vm._v(" "),_c('v-btn',{staticClass:"btn-auto btn-close",attrs:{"flat":"","color":"white"},on:{"click":_vm.hiddenBanner}},[_c('v-icon',{attrs:{"size":"25"}},[_vm._v("highlight_off")])],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_vue__ = __webpack_require__(572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c48f127_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c48f127"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c48f127_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(657);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("d74eda40", content, true, {});

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".banner[data-v-0c48f127]{background-image:url(\"https://mibodega.s3-sa-east-1.amazonaws.com/banner-app-2.png\");background-size:cover;background-position:bottom;height:445px;padding:36px 7% 0}@media (max-width:934px){.banner[data-v-0c48f127]{background-image:url(\"https://mibodega.s3-sa-east-1.amazonaws.com/banner-app-mobile-2.png\");height:823px;padding:73px 7% 0}}.wrappe-banner[data-v-0c48f127]{padding-top:68px}.wrappe-banner.no-margin[data-v-0c48f127]{padding-top:0}.wrapper-image[data-v-0c48f127]{margin-bottom:84px}@media (max-width:934px){.wrapper-image[data-v-0c48f127]{margin-bottom:35px;text-align:center}}.text-information[data-v-0c48f127]{color:#fff;font-size:29px;font-weight:600}@media (max-width:934px){.text-information[data-v-0c48f127]{font-size:20px;text-align:center}}.text-green[data-v-0c48f127]{color:#b1dc03}.link[data-v-0c48f127]{background:#fff;border-radius:7px;display:inline-block;color:#02979b;font-size:16px;font-weight:600;padding:8px;text-decoration:none;text-align:center}@media (max-width:934px){.link[data-v-0c48f127]{font-size:14px;padding:18px 0}}.btn-home[data-v-0c48f127]{background-color:rgba(2,151,155,.68);border:2px solid #b1dc03;border-radius:7px;color:#fff;font-weight:600;padding:8px 0;width:138px}.link-google[data-v-0c48f127]{display:inline-block}.link-google.mobile[data-v-0c48f127],.wrapper-links[data-v-0c48f127]{text-align:right}@media (max-width:934px){.desktop[data-v-0c48f127],.wrapper-links[data-v-0c48f127]{display:none}}.mobile[data-v-0c48f127]{display:none}@media (max-width:934px){.mobile[data-v-0c48f127]{display:block}}.wrapper-btns[data-v-0c48f127]{display:flex}@media (max-width:934px){.wrapper-btns[data-v-0c48f127]{text-align:center}}.wrapper-btn-mobile[data-v-0c48f127]{text-align:center}.image-mobile[data-v-0c48f127]{margin-top:-36px}.banner-information[data-v-0c48f127]{color:#fff;margin-top:16px}.disabled-btn[data-v-0c48f127]{background-color:#fff;border-radius:7px;bottom:0;cursor:not-allowed;left:0;opacity:.5;position:absolute;right:0;top:0}.wrapper-link[data-v-0c48f127]{position:relative}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/banner.vue"],"names":[],"mappings":"AACA,yBACE,qFAAsF,AACtF,sBAAuB,AACvB,2BAA4B,AAC5B,aAAc,AACd,iBAAsB,CACvB,AACD,yBACA,yBACM,4FAA6F,AAC7F,aAAc,AACd,iBAAsB,CAC3B,CACA,AACD,gCACE,gBAAkB,CACnB,AACD,0CACI,aAAiB,CACpB,AACD,gCACE,kBAAoB,CACrB,AACD,yBACA,gCACM,mBAAoB,AACpB,iBAAmB,CACxB,CACA,AACD,mCACE,WAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,yBACA,mCACM,eAAgB,AAChB,iBAAmB,CACxB,CACA,AACD,6BACE,aAAe,CAChB,AACD,uBACE,gBAAoB,AACpB,kBAAmB,AACnB,qBAAsB,AACtB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,qBAAsB,AACtB,iBAAmB,CACpB,AACD,yBACA,uBACM,eAAgB,AAChB,cAAgB,CACrB,CACA,AACD,2BACE,qCAA0C,AAC1C,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,gBAAiB,AACjB,cAAe,AACf,WAAa,CACd,AACD,8BACE,oBAAsB,CACvB,AAID,qEACE,gBAAkB,CACnB,AAMD,yBACA,0DACI,YAAc,CACjB,CACA,AACD,yBACE,YAAc,CACf,AACD,yBACA,yBACM,aAAe,CACpB,CACA,AACD,+BACE,YAAc,CACf,AACD,yBACA,+BACM,iBAAmB,CACxB,CACA,AACD,qCACE,iBAAmB,CACpB,AACD,+BACE,gBAAkB,CACnB,AACD,qCACE,WAAe,AACf,eAAiB,CAClB,AACD,+BACE,sBAA0B,AAC1B,kBAAmB,AACnB,SAAU,AACV,mBAAoB,AACpB,OAAQ,AACR,WAAa,AACb,kBAAmB,AACnB,QAAS,AACT,KAAO,CACR,AACD,+BACE,iBAAmB,CACpB","file":"banner.vue","sourcesContent":["\n.banner[data-v-0c48f127] {\n  background-image: url(\"https://mibodega.s3-sa-east-1.amazonaws.com/banner-app-2.png\");\n  background-size: cover;\n  background-position: bottom;\n  height: 445px;\n  padding: 36px 7% 0 7%;\n}\n@media (max-width: 934px) {\n.banner[data-v-0c48f127] {\n      background-image: url(\"https://mibodega.s3-sa-east-1.amazonaws.com/banner-app-mobile-2.png\");\n      height: 823px;\n      padding: 73px 7% 0 7%;\n}\n}\n.wrappe-banner[data-v-0c48f127] {\n  padding-top: 68px;\n}\n.wrappe-banner.no-margin[data-v-0c48f127] {\n    padding-top: 0px;\n}\n.wrapper-image[data-v-0c48f127] {\n  margin-bottom: 84px;\n}\n@media (max-width: 934px) {\n.wrapper-image[data-v-0c48f127] {\n      margin-bottom: 35px;\n      text-align: center;\n}\n}\n.text-information[data-v-0c48f127] {\n  color: #ffffff;\n  font-size: 29px;\n  font-weight: 600;\n}\n@media (max-width: 934px) {\n.text-information[data-v-0c48f127] {\n      font-size: 20px;\n      text-align: center;\n}\n}\n.text-green[data-v-0c48f127] {\n  color: #b1dc03;\n}\n.link[data-v-0c48f127] {\n  background: #ffffff;\n  border-radius: 7px;\n  display: inline-block;\n  color: #02979b;\n  font-size: 16px;\n  font-weight: 600;\n  padding: 8px;\n  text-decoration: none;\n  text-align: center;\n}\n@media (max-width: 934px) {\n.link[data-v-0c48f127] {\n      font-size: 14px;\n      padding: 18px 0;\n}\n}\n.btn-home[data-v-0c48f127] {\n  background-color: rgba(2, 151, 155, 0.68);\n  border: 2px solid #b1dc03;\n  border-radius: 7px;\n  color: #ffffff;\n  font-weight: 600;\n  padding: 8px 0;\n  width: 138px;\n}\n.link-google[data-v-0c48f127] {\n  display: inline-block;\n}\n.link-google.mobile[data-v-0c48f127] {\n    text-align: right;\n}\n.wrapper-links[data-v-0c48f127] {\n  text-align: right;\n}\n@media (max-width: 934px) {\n.wrapper-links[data-v-0c48f127] {\n      display: none;\n}\n}\n@media (max-width: 934px) {\n.desktop[data-v-0c48f127] {\n    display: none;\n}\n}\n.mobile[data-v-0c48f127] {\n  display: none;\n}\n@media (max-width: 934px) {\n.mobile[data-v-0c48f127] {\n      display: block;\n}\n}\n.wrapper-btns[data-v-0c48f127] {\n  display: flex;\n}\n@media (max-width: 934px) {\n.wrapper-btns[data-v-0c48f127] {\n      text-align: center;\n}\n}\n.wrapper-btn-mobile[data-v-0c48f127] {\n  text-align: center;\n}\n.image-mobile[data-v-0c48f127] {\n  margin-top: -36px;\n}\n.banner-information[data-v-0c48f127] {\n  color: #ffffff;\n  margin-top: 16px;\n}\n.disabled-btn[data-v-0c48f127] {\n  background-color: #ffffff;\n  border-radius: 7px;\n  bottom: 0;\n  cursor: not-allowed;\n  left: 0;\n  opacity: 0.5;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.wrapper-link[data-v-0c48f127] {\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrappe-banner",class:{ 'no-margin': !_vm.bannerVisible }},[_c('v-layout',{staticClass:"banner",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mobile wrapper-btn-mobile",attrs:{"xs12":""}},[_c('button',{staticClass:"btn-home"},[_vm._v("bodega.net")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('div',{staticClass:"wrapper-image"},[_c('button',{on:{"click":_vm.goToHome}},[_c('img',{attrs:{"src":(_vm.$S3 + "logo-mibodega-white.png"),"alt":"logo","height":"31"}})])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('p',{staticClass:"mb-0 text-information"},[_vm._v("BIENVENIDO eres "),_c('br',{staticClass:"mobile"}),_vm._v(" parte "),_c('br',{staticClass:"desktop"}),_vm._v("\n\t\t\t\t\t\t\tde los primeros"),_c('br',{staticClass:"mobile"}),_vm._v(" "),_c('span',{staticClass:"text-green"},[_vm._v(_vm._s(_vm.numberCoupon)+" NEGOCIOS VALIDADOS")])])]),_vm._v(" "),_c('div',{staticClass:"wrapper-btns"},[_c('div',{staticClass:"wrapper-link mr-3"},[(_vm.disabledRegisterApp)?_c('div',{staticClass:"disabled-btn"}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":_vm.disabledRegisterApp ? '#' : '#generate-app'}},[_vm._v("ACTIVA TU APP")])]),_vm._v(" "),_c('div',{staticClass:"wrapper-link"},[(_vm.disabledPayment)?_c('div',{staticClass:"disabled-btn"}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":_vm.disabledPayment ? '#' : _vm.linkPayment,"target":"_blank"}},[_vm._v("REALIZAR PAGO")])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('div',{staticClass:"wrapper-links"},[_c('button',{staticClass:"btn-home",on:{"click":_vm.goToHome}},[_vm._v("bodega.net")]),_vm._v(" "),_c('a',{staticClass:"link-google",attrs:{"href":_vm.linkGooglePlay,"target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "icon-google.png"),"alt":"google paly","height":"56px"}})])]),_vm._v(" "),_c('div',{staticClass:"mobile"},[_c('div',{staticClass:"mobile"},[_c('a',{staticClass:"link-google mobile",attrs:{"href":_vm.linkGooglePlay,"target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "icon-google.png"),"alt":"google play","height":"56px"}})])]),_vm._v(" "),_c('img',{staticClass:"image-mobile",attrs:{"src":(_vm.$S3 + "phone-app-screen-footer-min.png"),"alt":"mobile","width":"100%"}})])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_generate_app_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84bf31e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_generate_app_vue__ = __webpack_require__(676);
function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c84bf31e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_generate_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84bf31e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_generate_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(661);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("a1fe0286", content, true, {});

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-generate-app[data-v-c84bf31e]{padding:16px 7% 70px;position:relative}@media (max-width:959px){.section-generate-app[data-v-c84bf31e]{background-color:#fff;padding:50px 0}}.section-generate-app .pr-16[data-v-c84bf31e]{padding-right:16px}@media (max-width:959px){.section-generate-app .pr-16[data-v-c84bf31e]{padding-right:0}}.section-generate-app .pl-16[data-v-c84bf31e]{padding-left:16px}@media (max-width:959px){.section-generate-app .pl-16[data-v-c84bf31e]{padding-left:0}}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/section-generate-app.vue"],"names":[],"mappings":"AACA,uCACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,yBACA,uCACM,sBAA0B,AAC1B,cAAgB,CACrB,CACA,AACD,8CACI,kBAAoB,CACvB,AACD,yBACA,8CACQ,eAAmB,CAC1B,CACA,AACD,8CACI,iBAAmB,CACtB,AACD,yBACA,8CACQ,cAAkB,CACzB,CACA","file":"section-generate-app.vue","sourcesContent":["\n.section-generate-app[data-v-c84bf31e] {\n  padding: 16px 7% 70px;\n  position: relative;\n}\n@media (max-width: 959px) {\n.section-generate-app[data-v-c84bf31e] {\n      background-color: #ffffff;\n      padding: 50px 0;\n}\n}\n.section-generate-app .pr-16[data-v-c84bf31e] {\n    padding-right: 16px;\n}\n@media (max-width: 959px) {\n.section-generate-app .pr-16[data-v-c84bf31e] {\n        padding-right: 0px;\n}\n}\n.section-generate-app .pl-16[data-v-c84bf31e] {\n    padding-left: 16px;\n}\n@media (max-width: 959px) {\n.section-generate-app .pl-16[data-v-c84bf31e] {\n        padding-left: 0px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_generate_app_vue__ = __webpack_require__(574);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0028c334_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_generate_app_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0028c334"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_generate_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0028c334_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_generate_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(664);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("64ecba60", content, true, {});

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".title-form[data-v-0028c334]{border-bottom:2px solid #b1dc03;color:#02979b;font-family:Lato;font-weight:800;font-size:16px;margin-bottom:20px;padding-bottom:6px}@media (max-width:936px){.title-form[data-v-0028c334]{margin:0 20px 20px}}.input-component[data-v-0028c334]{border:1px solid #e9e9e9;border-radius:8px;height:40px;margin-bottom:20px;padding:0 15px;width:100%}.input-component[data-v-0028c334]:focus{outline:0}.input-component.upload[data-v-0028c334]{border-radius:8px 0 0 8px}.input-component.left-radius[data-v-0028c334]{border-bottom-left-radius:8px;border-bottom-right-radius:0;border-top-left-radius:8px;border-top-right-radius:0}.input-component.right-radius[data-v-0028c334]{border-bottom-left-radius:0;border-bottom-right-radius:8px;border-top-left-radius:0;border-top-right-radius:8px}@media (max-width:936px){.input-component[data-v-0028c334]{border-radius:3px;height:50px}}.btn-form[data-v-0028c334]{background:#02979b;border-radius:9px;color:#fff;font-family:Lato;font-size:16px;font-weight:900;padding:10px 35px}.form-generate-app[data-v-0028c334]{background:#fff;border-radius:8px;margin:19px auto 0;padding:0 45px 48px;max-width:592px;overflow:hidden}@media (max-width:936px){.form-generate-app[data-v-0028c334]{box-shadow:none;padding:0}}.center[data-v-0028c334]{text-align:center}.btn-upload[data-v-0028c334]{background-color:#b1dc03;border-radius:0 9px 9px 0;height:40px;padding:0 20px}@media (max-width:936px){.btn-upload[data-v-0028c334]{height:50px}}.caption[data-v-0028c334]{color:#909090;font-size:12px}.pt-21[data-v-0028c334]{padding-top:41px}.color[data-v-0028c334]{border-radius:50%;flex:1 1 auto;max-width:21px;height:21px}.wrapper-colors[data-v-0028c334]{display:flex;justify-content:space-around}.color-text[data-v-0028c334]{font-size:11px}.wrapper-btn[data-v-0028c334]{background-color:#f5f5f5;bottom:0;left:0;padding:25px 0;position:absolute;right:0;text-align:center;width:100%}@media (max-width:936px){.wrapper-btn[data-v-0028c334]{position:relative}}@media (max-width:936px){.wrapper-inputs[data-v-0028c334]{padding:0 20px}}.border[data-v-0028c334]{border:1px solid #eee}@media (min-width:936px){.padding-responsive[data-v-0028c334]{padding-right:15px}}.coupon-container[data-v-0028c334]{border:1px solid #085f65;border-radius:6px;height:44px;margin-bottom:16px;max-width:365px;text-transform:uppercase}.coupon-label[data-v-0028c334]{color:#8f8f8f;font-family:Lato;font-size:12px;font-weight:700}.coupon-value[data-v-0028c334]{color:#085f65;font-family:Lato;font-size:15px;font-weight:900;padding-left:5px}.implementation-cost[data-v-0028c334]{margin-bottom:20px}.implementation-cost-actual[data-v-0028c334]{color:rgba(8,95,101,.58);font-family:Lato;font-size:23px;font-weight:700;position:relative}.implementation-cost-actual[data-v-0028c334]:before{background-color:rgba(8,95,101,.58);bottom:15px;content:\"\";height:3px;left:-3px;position:absolute;transform:rotate(-7deg);width:110%}.implementation-cost-discount[data-v-0028c334]{color:#085f65;font-family:Lato;font-size:28px;font-weight:900;padding:0 28px}.implementation-cost-text[data-v-0028c334]{color:#8f8f8f;font-family:Lato;font-size:12px;font-weight:700;text-transform:uppercase}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/form-generate-app.vue"],"names":[],"mappings":"AACA,6BACE,gCAAiC,AACjC,cAAe,AACf,iBAAoB,AACpB,gBAAiB,AACjB,eAAgB,AAChB,mBAAoB,AACpB,kBAAoB,CACrB,AACD,yBACA,6BACM,kBAAyB,CAC9B,CACA,AACD,kCACE,yBAA0B,AAC1B,kBAAmB,AACnB,YAAa,AACb,mBAAoB,AACpB,eAAgB,AAChB,UAAY,CACb,AACD,wCACI,SAAa,CAChB,AACD,yCACI,yBAA2B,CAC9B,AACD,8CACI,8BAA+B,AAC/B,6BAAgC,AAChC,2BAA4B,AAC5B,yBAA6B,CAChC,AACD,+CACI,4BAA+B,AAC/B,+BAAgC,AAChC,yBAA4B,AAC5B,2BAA6B,CAChC,AACD,yBACA,kCACM,kBAAmB,AACnB,WAAa,CAClB,CACA,AACD,2BACE,mBAAoB,AACpB,kBAAmB,AACnB,WAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACpB,AACD,oCACE,gBAAoB,AACpB,kBAAmB,AACnB,mBAAsB,AACtB,oBAAuB,AACvB,gBAAiB,AACjB,eAAiB,CAClB,AACD,yBACA,oCACM,gBAAiB,AACjB,SAAW,CAChB,CACA,AACD,yBACE,iBAAmB,CACpB,AACD,6BACE,yBAA0B,AAC1B,0BAA2B,AAC3B,YAAa,AACb,cAAgB,CACjB,AACD,yBACA,6BACM,WAAa,CAClB,CACA,AACD,0BACE,cAAe,AACf,cAAgB,CACjB,AACD,wBACE,gBAAkB,CACnB,AACD,wBACE,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,WAAa,CACd,AACD,iCACE,aAAc,AACd,4BAA8B,CAC/B,AACD,6BACE,cAAgB,CACjB,AACD,8BACE,yBAA0B,AAC1B,SAAU,AACV,OAAQ,AACR,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,kBAAmB,AACnB,UAAY,CACb,AACD,yBACA,8BACM,iBAAmB,CACxB,CACA,AACD,yBACA,iCACI,cAAgB,CACnB,CACA,AACD,yBACE,qBAA0B,CAC3B,AACD,yBACA,qCACI,kBAAoB,CACvB,CACA,AACD,mCACE,yBAA0B,AAC1B,kBAAmB,AACnB,YAAa,AACb,mBAAoB,AACpB,gBAAiB,AACjB,wBAA0B,CAC3B,AACD,+BACE,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,eAAiB,CAClB,AACD,+BACE,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,gBAAkB,CACnB,AACD,sCACE,kBAAoB,CACrB,AACD,6CACI,yBAA8B,AAC9B,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oDACM,oCAAyC,AACzC,YAAa,AACb,WAAY,AACZ,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,wBAAyB,AACzB,UAAY,CACjB,AACD,+CACI,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,cAAkB,CACrB,AACD,2CACI,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,wBAA0B,CAC7B","file":"form-generate-app.vue","sourcesContent":["\n.title-form[data-v-0028c334] {\n  border-bottom: 2px solid #b1dc03;\n  color: #02979b;\n  font-family: \"Lato\";\n  font-weight: 800;\n  font-size: 16px;\n  margin-bottom: 20px;\n  padding-bottom: 6px;\n}\n@media (max-width: 936px) {\n.title-form[data-v-0028c334] {\n      margin: 0 20px 20px 20px;\n}\n}\n.input-component[data-v-0028c334] {\n  border: 1px solid #e9e9e9;\n  border-radius: 8px;\n  height: 40px;\n  margin-bottom: 20px;\n  padding: 0 15px;\n  width: 100%;\n}\n.input-component[data-v-0028c334]:focus {\n    outline: 0px;\n}\n.input-component.upload[data-v-0028c334] {\n    border-radius: 8px 0 0 8px;\n}\n.input-component.left-radius[data-v-0028c334] {\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 0px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 0px;\n}\n.input-component.right-radius[data-v-0028c334] {\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 8px;\n    border-top-left-radius: 0px;\n    border-top-right-radius: 8px;\n}\n@media (max-width: 936px) {\n.input-component[data-v-0028c334] {\n      border-radius: 3px;\n      height: 50px;\n}\n}\n.btn-form[data-v-0028c334] {\n  background: #02979b;\n  border-radius: 9px;\n  color: #ffffff;\n  font-family: \"Lato\";\n  font-size: 16px;\n  font-weight: 900;\n  padding: 10px 35px;\n}\n.form-generate-app[data-v-0028c334] {\n  background: #ffffff;\n  border-radius: 8px;\n  margin: 19px auto 0px;\n  padding: 0px 45px 48px;\n  max-width: 592px;\n  overflow: hidden;\n}\n@media (max-width: 936px) {\n.form-generate-app[data-v-0028c334] {\n      box-shadow: none;\n      padding: 0;\n}\n}\n.center[data-v-0028c334] {\n  text-align: center;\n}\n.btn-upload[data-v-0028c334] {\n  background-color: #b1dc03;\n  border-radius: 0 9px 9px 0;\n  height: 40px;\n  padding: 0 20px;\n}\n@media (max-width: 936px) {\n.btn-upload[data-v-0028c334] {\n      height: 50px;\n}\n}\n.caption[data-v-0028c334] {\n  color: #909090;\n  font-size: 12px;\n}\n.pt-21[data-v-0028c334] {\n  padding-top: 41px;\n}\n.color[data-v-0028c334] {\n  border-radius: 50%;\n  flex: 1 1 auto;\n  max-width: 21px;\n  height: 21px;\n}\n.wrapper-colors[data-v-0028c334] {\n  display: flex;\n  justify-content: space-around;\n}\n.color-text[data-v-0028c334] {\n  font-size: 11px;\n}\n.wrapper-btn[data-v-0028c334] {\n  background-color: #f5f5f5;\n  bottom: 0;\n  left: 0;\n  padding: 25px 0;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  width: 100%;\n}\n@media (max-width: 936px) {\n.wrapper-btn[data-v-0028c334] {\n      position: relative;\n}\n}\n@media (max-width: 936px) {\n.wrapper-inputs[data-v-0028c334] {\n    padding: 0 20px;\n}\n}\n.border[data-v-0028c334] {\n  border: 1px solid #eeeeee;\n}\n@media (min-width: 936px) {\n.padding-responsive[data-v-0028c334] {\n    padding-right: 15px;\n}\n}\n.coupon-container[data-v-0028c334] {\n  border: 1px solid #085f65;\n  border-radius: 6px;\n  height: 44px;\n  margin-bottom: 16px;\n  max-width: 365px;\n  text-transform: uppercase;\n}\n.coupon-label[data-v-0028c334] {\n  color: #8f8f8f;\n  font-family: \"Lato\";\n  font-size: 12px;\n  font-weight: 700;\n}\n.coupon-value[data-v-0028c334] {\n  color: #085f65;\n  font-family: \"Lato\";\n  font-size: 15px;\n  font-weight: 900;\n  padding-left: 5px;\n}\n.implementation-cost[data-v-0028c334] {\n  margin-bottom: 20px;\n}\n.implementation-cost-actual[data-v-0028c334] {\n    color: rgba(8, 95, 101, 0.58);\n    font-family: \"Lato\";\n    font-size: 23px;\n    font-weight: 700;\n    position: relative;\n}\n.implementation-cost-actual[data-v-0028c334]:before {\n      background-color: rgba(8, 95, 101, 0.58);\n      bottom: 15px;\n      content: '';\n      height: 3px;\n      left: -3px;\n      position: absolute;\n      transform: rotate(-7deg);\n      width: 110%;\n}\n.implementation-cost-discount[data-v-0028c334] {\n    color: #085f65;\n    font-family: \"Lato\";\n    font-size: 28px;\n    font-weight: 900;\n    padding: 0px 28px;\n}\n.implementation-cost-text[data-v-0028c334] {\n    color: #8f8f8f;\n    font-family: \"Lato\";\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),o=n(5),i=n(2),l=i(r.a,o.a,!1,null,null,null);t.default=l.exports},function(e,t){e.exports=function(e,t,n,r,o,i){var l,u=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(l=e,u=e.default);var a="function"==typeof u?u.options:u;t&&(a.render=t.render,a.staticRenderFns=t.staticRenderFns,a._compiled=!0),n&&(a.functional=!0),o&&(a._scopeId=o);var c;if(i?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i)},a._ssrRegister=c):r&&(c=r),c){var f=a.functional,p=f?a.render:a.beforeCreate;f?(a._injectStyles=c,a.render=function(e,t){return c.call(t),p(e,t)}):a.beforeCreate=p?[].concat(p,c):[c]}return{esModule:l,exports:u,options:a}}},function(e,t,n){"use strict";function r(){return{multipleFiles:[]}}function o(e){for(var t=this,n=e.target.files,r=n.length,o=0;o<r;o+=1)(function(e){var o=n[e],i=new FileReader;i.readAsDataURL(o),i.addEventListener("load",function(){var e=l()(o,{sixFour:i.result});t.multipleFiles.push(e),r===t.multipleFiles.length&&(t.$emit("vue-six-four",t.allowMultiple?t.multipleFiles:t.multipleFiles[0]),t.multipleFiles=[]),i=null})})(o)}var i=n(4),l=n.n(i);t.a={data:r,name:"vue-six-four",methods:{readFile:o},props:{allowMultiple:{type:Boolean,default:!1}}}},function(e,t){e.exports=__webpack_require__(70)},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{attrs:{type:"file",multiple:e.allowMultiple},on:{change:e.readFile}})},o=[],i={render:r,staticRenderFns:o};t.a=i}]);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);


function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var splitBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var newDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(year, month, day), formatter);
		return newDate;
	}
	return null;
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

	var newDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(date), formatter);
	return newDate;
}

function generateBlob(data) {
	var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'application/pdf';

	return new Blob([data], { type: contentType });
}

function showDownloadDialog(blob, name, extension) {
	var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = name + '_' + currentDate + '.' + extension;
	link.href = window.URL.createObjectURL(blob);
	link.click();
}

/* eslint-disable */
function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
	var immediate = arguments[2];

	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var methods = {
	debounce: debounce,
	exactDate: exactDate,
	formatDate: formatDate,
	generateBlob: generateBlob,
	showDownloadDialog: showDownloadDialog
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_color_vue__ = __webpack_require__(575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908cf720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_color_vue__ = __webpack_require__(670);
function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-908cf720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_color_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908cf720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_color_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(669);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("c97618ac", content, true, {});

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".color[data-v-908cf720]{border-radius:50%;height:32px;margin:auto;width:32px}.border[data-v-908cf720]{border:1px solid #eee}.btn-color[data-v-908cf720]{border:1px solid #eee;border-radius:9px;padding:13px 0;margin-bottom:10px;width:100%}.btn-color.select[data-v-908cf720],.btn-color[data-v-908cf720]:hover{border:1px solid #b1dc03}.title[data-v-908cf720]{color:#00888c;font-size:17px!important;font-weight:600}.select-color[data-v-908cf720]{margin:36px 0 46px}@media (max-width:959px){.wrapper-colors[data-v-908cf720]{padding:0 30px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/select-color.vue"],"names":[],"mappings":"AACA,wBACE,kBAAmB,AACnB,YAAa,AACb,YAAa,AACb,UAAY,CACb,AACD,yBACE,qBAA0B,CAC3B,AACD,4BACE,sBAA0B,AAC1B,kBAAmB,AACnB,eAAgB,AAChB,mBAAoB,AACpB,UAAY,CACb,AACD,qEACI,wBAA0B,CAC7B,AACD,wBACE,cAAe,AACf,yBAA2B,AAC3B,eAAiB,CAClB,AACD,+BACE,kBAAsB,CACvB,AACD,yBACA,iCACI,cAAgB,CACnB,CACA","file":"select-color.vue","sourcesContent":["\n.color[data-v-908cf720] {\n  border-radius: 50%;\n  height: 32px;\n  margin: auto;\n  width: 32px;\n}\n.border[data-v-908cf720] {\n  border: 1px solid #eeeeee;\n}\n.btn-color[data-v-908cf720] {\n  border: 1px solid #eeeeee;\n  border-radius: 9px;\n  padding: 13px 0;\n  margin-bottom: 10px;\n  width: 100%;\n}\n.btn-color[data-v-908cf720]:hover, .btn-color.select[data-v-908cf720] {\n    border: 1px solid #b1dc03;\n}\n.title[data-v-908cf720] {\n  color: #00888c;\n  font-size: 17px !important;\n  font-weight: 600;\n}\n.select-color[data-v-908cf720] {\n  margin: 36px 0 46px 0;\n}\n@media (max-width: 959px) {\n.wrapper-colors[data-v-908cf720] {\n    padding: 0 30px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-color"},[_c('p',{staticClass:"title"},[_vm._v("Selecciona una paleta de colores")]),_vm._v(" "),_c('v-layout',{staticClass:"wrapper-colors",attrs:{"wrap":""}},_vm._l((_vm.colors),function(item){return _c('v-flex',{key:item.id,attrs:{"xs12":"","md6":"","px-1":""}},[_c('button',{staticClass:"btn-color",class:{'select': item.id === _vm.colorId},attrs:{"type":"button"},on:{"click":function($event){_vm.selectColor(item)}}},[_c('v-layout',[_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"color",style:(("background-color: " + (item.colorOne)))})]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"color",style:(("background-color: " + (item.colorTwo)))})]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"color border",style:(("background-color: " + (item.colorThree)))})]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"color",style:(("background-color: " + (item.colorFour)))})])],1)],1)])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-generate-app",on:{"submit":function($event){$event.preventDefault();return _vm.generateApp($event)}}},[_c('p',{staticClass:"title-form"},[_vm._v("DATOS DE NEGOCIO")]),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 wrapper-inputs",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{staticClass:"input-component",attrs:{"label":"Rubro","item-text":"name","item-value":"name","items":_vm.activities,"hide-details":"","autocomplete":"","single-line":""},model:{value:(_vm.model.business),callback:function ($$v) {_vm.$set(_vm.model, "business", $$v)},expression:"model.business"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nameWarehouse),expression:"model.nameWarehouse"}],staticClass:"input-component",attrs:{"type":"text","placeholder":"Nombre de tu negocio"},domProps:{"value":(_vm.model.nameWarehouse)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nameWarehouse", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{staticClass:"input-component",attrs:{"label":_vm.captionDepartament,"item-text":"name","item-value":"name","items":_vm.departaments,"hide-details":"","autocomplete":"","single-line":""},model:{value:(_vm.model.department),callback:function ($$v) {_vm.$set(_vm.model, "department", $$v)},expression:"model.department"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.address),expression:"model.address"}],staticClass:"input-component",attrs:{"type":"text","placeholder":"Tu dirección"},domProps:{"value":(_vm.model.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "address", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{staticClass:"padding-responsive",attrs:{"xs12":"","md6":""}},[_c('label',{staticClass:"caption",attrs:{"for":"color"}},[_vm._v("Escoge tu paleta de colores (5)")]),_vm._v(" "),_c('v-select',{staticClass:"input-component",attrs:{"id":"color","disabled":_vm.loadingColor,"label":"Tus colores","item-text":"value","item-value":"id","items":_vm.colors,"hide-details":"","single-line":"","return-object":""},on:{"change":_vm.changeColor},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"wrapper-colors"},[_c('div',{staticClass:"color",style:(("background-color: " + (data.item.primary)))}),_vm._v(" "),_c('div',{staticClass:"color",style:(("background-color: " + (data.item.secondary)))}),_vm._v(" "),_c('div',{staticClass:"color",style:(("background-color: " + (data.item.tertiary)))}),_vm._v(" "),_c('div',{staticClass:"color border",style:(("background-color: " + (data.item.fourth)))}),_vm._v(" "),_c('div',{staticClass:"color",style:(("background-color: " + (data.item.fifth)))})])])],1)]}},{key:"item",fn:function(data){return [_c('v-layout',[_c('v-flex',{staticClass:"color-text",attrs:{"xs3":""}},[_vm._v("Paleta "+_vm._s(data.item.id))]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","pl-1":""}},[_c('div',{staticClass:"wrapper-colors"},[_c('div',{staticClass:"color",style:(("background-color: " + (data.item.primary)))}),_vm._v(" "),_c('div',{staticClass:"color",style:(("background-color: " + (data.item.secondary)))}),_vm._v(" "),_c('div',{staticClass:"color",style:(("background-color: " + (data.item.tertiary)))}),_vm._v(" "),_c('div',{staticClass:"color border",style:(("background-color: " + (data.item.fourth)))}),_vm._v(" "),_c('div',{staticClass:"color",style:(("background-color: " + (data.item.fifth)))})])])],1)]}}]),model:{value:(_vm.model.color),callback:function ($$v) {_vm.$set(_vm.model, "color", $$v)},expression:"model.color"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"padding-responsive",attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs10":"","md9":""}},[_c('label',{staticClass:"caption",attrs:{"for":"logo"}},[_vm._v("Sube tu logo (si no tienes lo puedes subir más tarde)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.logo),expression:"model.logo"}],staticClass:"input-component upload",attrs:{"placeholder":"logo.jpg","id":"logo","readonly":""},domProps:{"value":(_vm.model.logo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "logo", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{staticClass:"pt-21",attrs:{"xs2":"","md3":""}},[_c('label',{ref:"up",attrs:{"for":"upload-image"}},[_c('vue-six-four',{attrs:{"id":"upload-image","hidden":""},on:{"vue-six-four":function($event){_vm.getFile($event, 'logo')}}}),_vm._v(" "),_c('button',{staticClass:"btn-upload",attrs:{"type":"button"},on:{"click":function($event){_vm.actionUploadImage('up')}}},[_c('img',{attrs:{"src":"/static/images/banners/upload.svg","alt":"upload","height":"18"}})])],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs10":"","md9":""}},[_c('label',{staticClass:"caption",attrs:{"for":"background"}},[_vm._v("Sube tu fondo (si no tienes lo puedes subir más tarde)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.background),expression:"model.background"}],staticClass:"input-component upload",attrs:{"placeholder":"fondo.jpg","id":"background","readonly":""},domProps:{"value":(_vm.model.background)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "background", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{staticClass:"pt-21",attrs:{"xs2":"","md3":""}},[_c('label',{ref:"upBackground",attrs:{"for":"upload-image-background"}},[_c('vue-six-four',{attrs:{"id":"upload-image-background","hidden":""},on:{"vue-six-four":function($event){_vm.getFile($event, 'background')}}}),_vm._v(" "),_c('button',{staticClass:"btn-upload",attrs:{"type":"button"},on:{"click":function($event){_vm.actionUploadImage('upBackground')}}},[_c('img',{attrs:{"src":"/static/images/banners/upload.svg","alt":"upload","height":"18"}})])],1)])],1)],1)],1)],1)],1),_vm._v(" "),_c('p',{staticClass:"title-form"},[_vm._v("DATOS DE CONTACTO")]),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 wrapper-inputs",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"input-component",attrs:{"type":"text","placeholder":"Tu nombre"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.surName),expression:"model.surName"}],staticClass:"input-component",attrs:{"type":"text","placeholder":"Tus apellidos"},domProps:{"value":(_vm.model.surName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "surName", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{staticClass:"input-component left-radius",attrs:{"label":"Tu país","item-text":"value","item-value":"name","items":_vm.countries,"hide-details":"","single-line":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('div',[_c('img',{attrs:{"src":data.item.image,"alt":data.item.name,"height":"20"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.value))])])]}},{key:"item",fn:function(data){return [_c('div',[_c('img',{attrs:{"src":data.item.image,"alt":data.item.name,"height":"20"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.value))])])]}}]),model:{value:(_vm.model.country),callback:function ($$v) {_vm.$set(_vm.model, "country", $$v)},expression:"model.country"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.phone),expression:"model.phone"}],staticClass:"input-component right-radius",attrs:{"type":"number","placeholder":"Tu celular"},domProps:{"value":(_vm.model.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "phone", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"input-component",attrs:{"type":"email","placeholder":"Tu correo electrónico"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"input-component",attrs:{"type":"password","placeholder":"Tu contraseña"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}})])],1),_vm._v(" "),_c('p',{staticClass:"title-form"},[_vm._v("COSTO DE IMPLEMENTACIÓN")]),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 wrapper-inputs",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"layout wrap align-center justify-center coupon-container"},[_c('span',{staticClass:"coupon-label"},[_vm._v("Cupón de descuento:")]),_vm._v(" "),_c('span',{staticClass:"coupon-value"},[_vm._v(_vm._s(_vm.couponValue))])]),_vm._v(" "),_c('div',{staticClass:"layout wrap align-center implementation-cost"},[_c('span',{staticClass:"implementation-cost-actual"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm.costActual)+"\n\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"implementation-cost-discount"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm._f("round")(_vm.costWithDiscount))+"\n\t\t\t\t")]),_vm._v(" "),_c('span',{staticClass:"implementation-cost-text"},[_vm._v("Incluye "+_vm._s(_vm.taxLabel))])]),_vm._v(" "),_c('div',{staticClass:"layout wrap align-center justify-center coupon-container"},[_c('span',{staticClass:"coupon-label"},[_vm._v("Pedicréditos de regalo:")]),_vm._v(" "),_c('span',{staticClass:"coupon-value"},[_vm._v(_vm._s(_vm.creditQuantity)+" creditos gratis")])])])],1),_vm._v(" "),_c('v-layout',{staticClass:"title-form",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('p',{staticClass:"ma-0"},[_vm._v("¿DESEAS FACTURA?")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"color":"success","hide-details":""},model:{value:(_vm.billingCheck),callback:function ($$v) {_vm.billingCheck=$$v},expression:"billingCheck"}})],1)],1),_vm._v(" "),(_vm.billingCheck)?_c('v-layout',{staticClass:"wrapper-inputs",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ruc),expression:"model.ruc"}],staticClass:"input-component",attrs:{"type":"text","placeholder":"RUC"},domProps:{"value":(_vm.model.ruc)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ruc", $event.target.value)},_vm.rucValidate]}})])],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"wrapper-btn"},[_c('v-flex',{attrs:{"xs12":""}},[_c('button',{staticClass:"btn-form",attrs:{"disabled":_vm.disabledRegisterApp || _vm.disabledBtn,"type":"submit"}},[_vm._v("ACTIVA TU APP")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_phone_vue__ = __webpack_require__(576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_746d8864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_phone_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-746d8864"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_phone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_746d8864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_phone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(674);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("1c74fb2c", content, true, {});

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-slider[data-v-746d8864]{align-items:center;background-color:#f4f4f4;box-shadow:0 2px 12px 0 rgba(0,0,0,.07);border-radius:15px;display:flex;justify-content:center;height:779px;margin:24px auto 0;padding:36px 1% 48px;position:relative;width:93%}@media (min-width:936px){.section-slider[data-v-746d8864]{height:60%;margin:0;width:100%}}.section-slider.section-gallery[data-v-746d8864]{padding:0;text-align:center}@media (min-width:936px){.section-slider.section-gallery[data-v-746d8864]{bottom:0;height:100%;margin:35px 0 auto auto;right:10%;top:0;width:50%}}.section-slider-slide[data-v-746d8864]{height:100%}.section-gallery[data-v-746d8864]{height:670px;margin-top:356px;width:82%}.section-gallery .section-slider-slides[data-v-746d8864]{height:965px!important;margin-bottom:0;margin-top:0;top:-178px}@media (min-width:768px){.section-gallery .section-slider-slides[data-v-746d8864]{height:810px!important;top:-98px}}@media (min-width:936px){.section-gallery .section-slider-slides[data-v-746d8864]{height:529px!important;top:2px}}@media (min-width:768px){.section-gallery[data-v-746d8864]{margin-top:190px}}@media (min-width:936px){.section-gallery[data-v-746d8864]{margin-top:0}}.section-gallery .slider-item[data-v-746d8864]{top:356px}@media (min-width:768px){.section-gallery .slider-item[data-v-746d8864]{top:200px}}@media (min-width:936px){.section-gallery .slider-item[data-v-746d8864]{top:0}}.slide-case[data-v-746d8864]{height:571px;position:relative;width:274px;z-index:1}@media (min-width:936px){.slide-case[data-v-746d8864]{height:641px;width:309px}}.section-slider-slide-1[data-v-746d8864],.section-slider-slide-2[data-v-746d8864],.section-slider-slide-3[data-v-746d8864],.section-slider-slide-4[data-v-746d8864],.slide-background[data-v-746d8864],.slide-logo[data-v-746d8864]{border-radius:0;position:absolute}.slide-logo[data-v-746d8864]{height:25px;left:-5px;margin:auto;right:0;top:168px;width:132px;z-index:1}@media (min-width:936px){.slide-logo[data-v-746d8864]{height:auto;max-height:50px;max-width:148px;top:189px;width:auto}}.slide-background[data-v-746d8864]{left:11px;height:91.1%;top:13px;width:91%}@media (min-width:936px){.slide-background[data-v-746d8864]{left:13px;top:15px}}.section-slider-slide-1[data-v-746d8864]{height:126px;left:-5px;margin:auto;right:0;top:254px;width:209px;z-index:1}@media (min-width:936px){.section-slider-slide-1[data-v-746d8864]{height:141px;top:285px;width:235px}}.section-slider-slide-2[data-v-746d8864],.section-slider-slide-3[data-v-746d8864],.section-slider-slide-4[data-v-746d8864]{height:91%;left:12px;top:14px;width:91%}@media (min-width:936px){.section-slider-slide-2[data-v-746d8864],.section-slider-slide-3[data-v-746d8864],.section-slider-slide-4[data-v-746d8864]{left:13px;top:16px}}.section-slide-container[data-v-746d8864]{margin:auto;position:relative;width:fit-content;width:-moz-fit-content}.loader[data-v-746d8864]{align-items:center;background:rgba(0,0,0,.3);border-radius:8px;display:flex;height:100%;justify-content:center;position:absolute;top:1px;width:100%;z-index:100}.btn-see-customers[data-v-746d8864]{border-radius:100%;box-shadow:0 2px 7px 0 rgba(0,0,0,.13)!important;height:54px!important;width:54px!important}.btn-customers[data-v-746d8864]{position:absolute;right:18px;top:20px;z-index:200}.bar-title[data-v-746d8864]{align-items:center;background:#02979b;border-radius:5px;display:flex;color:#fff;font-family:Lato;font-size:20px;font-weight:900;height:57px;justify-content:center;margin:10px auto 0;max-width:90%;position:relative}.bar-title-btn[data-v-746d8864]{bottom:0;margin:auto;position:absolute;right:10px;top:0}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/section-phone.vue"],"names":[],"mappings":"AACA,iCACE,mBAAoB,AACpB,yBAA0B,AAC1B,wCAA6C,AAC7C,mBAAoB,AACpB,aAAc,AACd,uBAAwB,AACxB,aAAc,AACd,mBAAsB,AACtB,qBAAsB,AACtB,kBAAmB,AACnB,SAAW,CACZ,AACD,yBACA,iCACM,WAAY,AACZ,SAAY,AACZ,UAAY,CACjB,CACA,AACD,iDACI,UAAa,AACb,iBAAmB,CACtB,AACD,yBACA,iDACQ,SAAU,AACV,YAAa,AACb,wBAA2B,AAC3B,UAAW,AACX,MAAO,AACP,SAAW,CAClB,CACA,AACD,uCACE,WAAa,CACd,AACD,kCACE,aAAc,AACd,iBAAkB,AAClB,SAAW,CACZ,AACD,yDACI,uBAAyB,AACzB,gBAAmB,AACnB,aAAgB,AAChB,UAAY,CACf,AACD,yBACA,yDACQ,uBAAyB,AACzB,SAAW,CAClB,CACA,AACD,yBACA,yDACQ,uBAAyB,AACzB,OAAS,CAChB,CACA,AACD,yBACA,kCACM,gBAAkB,CACvB,CACA,AACD,yBACA,kCACM,YAAgB,CACrB,CACA,AACD,+CACI,SAAW,CACd,AACD,yBACA,+CACQ,SAAW,CAClB,CACA,AACD,yBACA,+CACQ,KAAS,CAChB,CACA,AACD,6BACE,aAAc,AACd,kBAAmB,AACnB,YAAa,AACb,SAAW,CACZ,AACD,yBACA,6BACM,aAAc,AACd,WAAa,CAClB,CACA,AACD,oOAME,gBAAmB,AACnB,iBAAmB,CACpB,AACD,6BACE,YAAa,AACb,UAAW,AACX,YAAa,AACb,QAAW,AACX,UAAW,AACX,YAAa,AACb,SAAW,CACZ,AACD,yBACA,6BACM,YAAa,AACb,gBAAiB,AACjB,gBAAiB,AACjB,UAAW,AACX,UAAY,CACjB,CACA,AACD,mCACE,UAAW,AACX,aAAc,AACd,SAAU,AACV,SAAW,CACZ,AACD,yBACA,mCACM,UAAW,AACX,QAAU,CACf,CACA,AACD,yCACE,aAAc,AACd,UAAW,AACX,YAAa,AACb,QAAS,AACT,UAAW,AACX,YAAa,AACb,SAAW,CACZ,AACD,yBACA,yCACM,aAAc,AACd,UAAW,AACX,WAAa,CAClB,CACA,AACD,2HAGE,WAAY,AACZ,UAAW,AACX,SAAU,AACV,SAAW,CACZ,AACD,yBACA,2HAGM,UAAW,AACX,QAAU,CACf,CACA,AACD,0CACE,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,sBAAwB,CACzB,AACD,yBACE,mBAAoB,AACpB,0BAA+B,AAC/B,kBAAmB,AACnB,aAAc,AACd,YAAa,AACb,uBAAwB,AACxB,kBAAmB,AACnB,QAAS,AACT,WAAY,AACZ,WAAa,CACd,AACD,oCACE,mBAAoB,AACpB,iDAAuD,AACvD,sBAAwB,AACxB,oBAAuB,CACxB,AACD,gCACE,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,WAAa,CACd,AACD,4BACE,mBAAoB,AACpB,mBAAoB,AACpB,kBAAmB,AACnB,aAAc,AACd,WAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,uBAAwB,AACxB,mBAAsB,AACtB,cAAe,AACf,iBAAmB,CACpB,AACD,gCACI,SAAU,AACV,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,KAAO,CACV","file":"section-phone.vue","sourcesContent":["\n.section-slider[data-v-746d8864] {\n  align-items: center;\n  background-color: #f4f4f4;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.07);\n  border-radius: 15px;\n  display: flex;\n  justify-content: center;\n  height: 779px;\n  margin: 24px auto 0px;\n  padding: 36px 1% 48px;\n  position: relative;\n  width: 93%;\n}\n@media (min-width: 936px) {\n.section-slider[data-v-746d8864] {\n      height: 60%;\n      margin: 0px;\n      width: 100%;\n}\n}\n.section-slider.section-gallery[data-v-746d8864] {\n    padding: 0px;\n    text-align: center;\n}\n@media (min-width: 936px) {\n.section-slider.section-gallery[data-v-746d8864] {\n        bottom: 0;\n        height: 100%;\n        margin: 35px 0px auto auto;\n        right: 10%;\n        top: 0;\n        width: 50%;\n}\n}\n.section-slider-slide[data-v-746d8864] {\n  height: 100%;\n}\n.section-gallery[data-v-746d8864] {\n  height: 670px;\n  margin-top: 356px;\n  width: 82%;\n}\n.section-gallery .section-slider-slides[data-v-746d8864] {\n    height: 965px !important;\n    margin-bottom: 0px;\n    margin-top: 0px;\n    top: -178px;\n}\n@media (min-width: 768px) {\n.section-gallery .section-slider-slides[data-v-746d8864] {\n        height: 810px !important;\n        top: -98px;\n}\n}\n@media (min-width: 936px) {\n.section-gallery .section-slider-slides[data-v-746d8864] {\n        height: 529px !important;\n        top: 2px;\n}\n}\n@media (min-width: 768px) {\n.section-gallery[data-v-746d8864] {\n      margin-top: 190px;\n}\n}\n@media (min-width: 936px) {\n.section-gallery[data-v-746d8864] {\n      margin-top: 0px;\n}\n}\n.section-gallery .slider-item[data-v-746d8864] {\n    top: 356px;\n}\n@media (min-width: 768px) {\n.section-gallery .slider-item[data-v-746d8864] {\n        top: 200px;\n}\n}\n@media (min-width: 936px) {\n.section-gallery .slider-item[data-v-746d8864] {\n        top: 0px;\n}\n}\n.slide-case[data-v-746d8864] {\n  height: 571px;\n  position: relative;\n  width: 274px;\n  z-index: 1;\n}\n@media (min-width: 936px) {\n.slide-case[data-v-746d8864] {\n      height: 641px;\n      width: 309px;\n}\n}\n.slide-logo[data-v-746d8864],\n.slide-background[data-v-746d8864],\n.section-slider-slide-1[data-v-746d8864],\n.section-slider-slide-2[data-v-746d8864],\n.section-slider-slide-3[data-v-746d8864],\n.section-slider-slide-4[data-v-746d8864] {\n  border-radius: 0px;\n  position: absolute;\n}\n.slide-logo[data-v-746d8864] {\n  height: 25px;\n  left: -5px;\n  margin: auto;\n  right: 0px;\n  top: 168px;\n  width: 132px;\n  z-index: 1;\n}\n@media (min-width: 936px) {\n.slide-logo[data-v-746d8864] {\n      height: auto;\n      max-height: 50px;\n      max-width: 148px;\n      top: 189px;\n      width: auto;\n}\n}\n.slide-background[data-v-746d8864] {\n  left: 11px;\n  height: 91.1%;\n  top: 13px;\n  width: 91%;\n}\n@media (min-width: 936px) {\n.slide-background[data-v-746d8864] {\n      left: 13px;\n      top: 15px;\n}\n}\n.section-slider-slide-1[data-v-746d8864] {\n  height: 126px;\n  left: -5px;\n  margin: auto;\n  right: 0;\n  top: 254px;\n  width: 209px;\n  z-index: 1;\n}\n@media (min-width: 936px) {\n.section-slider-slide-1[data-v-746d8864] {\n      height: 141px;\n      top: 285px;\n      width: 235px;\n}\n}\n.section-slider-slide-2[data-v-746d8864],\n.section-slider-slide-3[data-v-746d8864],\n.section-slider-slide-4[data-v-746d8864] {\n  height: 91%;\n  left: 12px;\n  top: 14px;\n  width: 91%;\n}\n@media (min-width: 936px) {\n.section-slider-slide-2[data-v-746d8864],\n    .section-slider-slide-3[data-v-746d8864],\n    .section-slider-slide-4[data-v-746d8864] {\n      left: 13px;\n      top: 16px;\n}\n}\n.section-slide-container[data-v-746d8864] {\n  margin: auto;\n  position: relative;\n  width: fit-content;\n  width: -moz-fit-content;\n}\n.loader[data-v-746d8864] {\n  align-items: center;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  position: absolute;\n  top: 1px;\n  width: 100%;\n  z-index: 100;\n}\n.btn-see-customers[data-v-746d8864] {\n  border-radius: 100%;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.13) !important;\n  height: 54px !important;\n  width: 54px !important;\n}\n.btn-customers[data-v-746d8864] {\n  position: absolute;\n  right: 18px;\n  top: 20px;\n  z-index: 200;\n}\n.bar-title[data-v-746d8864] {\n  align-items: center;\n  background: #02979b;\n  border-radius: 5px;\n  display: flex;\n  color: #ffffff;\n  font-family: \"Lato\";\n  font-size: 20px;\n  font-weight: 900;\n  height: 57px;\n  justify-content: center;\n  margin: 10px auto 0px;\n  max-width: 90%;\n  position: relative;\n}\n.bar-title-btn[data-v-746d8864] {\n    bottom: 0;\n    margin: auto;\n    position: absolute;\n    right: 10px;\n    top: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-slider"},[(_vm.showLoader)?_c('div',{staticClass:"loader"},[_c('v-progress-circular',{attrs:{"color":("theme" + _vm.themeId),"indeterminate":"","size":50}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-customers"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"btn-auto btn-see-customers",attrs:{"slot":"activator","color":"accent","depressed":""},on:{"click":_vm.showGallery},slot:"activator"},[_c('img',{attrs:{"src":"/static/images/icons/btn-customers.svg","alt":"","height":"30"}})]),_vm._v(" "),_c('span',[_vm._v("Mira nuestros clientes")])],1)],1),_vm._v(" "),_c('slider',{staticClass:"section-slider-slides",attrs:{"animation":"fade","autoplay":false,"height":"100%","indicators":false,"interval":5000,"speed":2000}},_vm._l((_vm.slides),function(slide){return _c('slider-item',{key:slide.id,staticClass:"section-slider-slides-item"},[_c('v-layout',{staticClass:"section-slider-slide",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-slider-column",attrs:{"xs12":""}},[_c('div',{staticClass:"section-slide-container"},[_c('img',{staticClass:"slide-case",attrs:{"src":"/static/images/simulator/phone-case.png","alt":"case"}}),_vm._v(" "),(slide.id === 1)?[(_vm.logo)?_c('img',{staticClass:"slide-logo",attrs:{"alt":"logo","height":"24","src":_vm.logo}}):_vm._e(),_vm._v(" "),(_vm.background)?_c('img',{staticClass:"slide-background",attrs:{"alt":"fondo","src":_vm.background}}):_vm._e()]:_vm._e(),_vm._v(" "),_c('img',{class:slide.class,attrs:{"alt":slide.alt,"src":slide.image}})],2)])],1)],1)})),_vm._v(" "),_c('v-dialog',{attrs:{"content-class":"dialog-gallery","persistent":"","max-width":"70%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"bar-title"},[_vm._v("\n\t\t\t\t\t\tNuestros Clientes\n\t\t\t\t\t\t"),_c('v-btn',{staticClass:"btn-auto bar-title-btn",attrs:{"depressed":"","icon":""},on:{"click":_vm.hiddenDialog}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("close")])],1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"section-slider section-gallery"},[_c('slider',{staticClass:"section-slider-slides",attrs:{"animation":"fade","autoplay":false,"height":"100%","indicators":"left","interval":5000,"speed":2000}},_vm._l((_vm.gallery),function(slide,index){return _c('slider-item',{key:index,staticClass:"section-slider-slides-item"},[_c('v-layout',{staticClass:"section-slider-slide",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"section-slider-column",attrs:{"xs12":""}},[_c('img',{attrs:{"alt":"cliente validado","src":slide}})])],1)],1)}))],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-generate-app",attrs:{"wrap":"","id":"generate-app","justify-center":""}},[_c('v-flex',{staticClass:"pr-16 max-600",attrs:{"xs12":"","md6":""}},[_c('div',[_c('form-generate-app',{attrs:{"disabled-register-app":_vm.disabledRegisterApp,"departaments":_vm.departaments,"token":_vm.token},on:{"change-background":_vm.changeBackground,"change-color":_vm.changeColor,"change-logo":_vm.changeLogo}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"pl-16 max-600",attrs:{"xs12":"","md6":""}},[_c('section-phone',{attrs:{"background":_vm.background,"color-select":_vm.colorSelect,"loading-background":_vm.loadingBackground,"loading-color":_vm.loadingColor,"loading-logo":_vm.loadingLogo,"logo":_vm.logo,"theme-id":_vm.colorSelect.id}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_benefits_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491abc2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_benefits_vue__ = __webpack_require__(680);
function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-491abc2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_benefits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491abc2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_benefits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(679);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("b6db61c2", content, true, {});

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-benefits[data-v-491abc2b]{background-color:#fafafa;padding:81px 7% 102px}.benefits-title[data-v-491abc2b]{color:#085f65;font-family:Lato;font-size:30px;font-weight:900;margin-bottom:50px;text-align:center}@media (max-width:936px){.benefits-title[data-v-491abc2b]{font-size:24px}}.wrapper-points[data-v-491abc2b]{background-color:#fff;box-shadow:0 2px 20px 0 rgba(0,0,0,.06);border-radius:20px;padding:83px 70px}@media (max-width:936px){.wrapper-points[data-v-491abc2b]{padding:47px 20px}}.number[data-v-491abc2b]{background-color:#b1dc03;border-radius:50%;color:#02979b;font-size:18px;font-weight:600;height:34px;padding-top:4px;text-align:center;width:34px}.text[data-v-491abc2b]{color:#8f8f8f;font-size:20px;line-height:25px}@media (max-width:936px){.text[data-v-491abc2b]{font-size:16px}}.sub-text[data-v-491abc2b]{color:#8f8f8f;font-size:18px}@media (max-width:936px){.sub-text[data-v-491abc2b]{font-size:16px}}.mb-text[data-v-491abc2b]{margin-bottom:16px}.pr-48[data-v-491abc2b]{padding-right:48px}@media (max-width:936px){.pr-48[data-v-491abc2b]{padding-right:0}}.pl-48[data-v-491abc2b]{padding-left:48px}@media (max-width:936px){.pl-48[data-v-491abc2b]{padding-left:0}}@media (max-width:936px){.check[data-v-491abc2b]{height:22px}}.href-here[data-v-491abc2b]{color:#02979b;font-size:20px;font-weight:900}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/section-benefits.vue"],"names":[],"mappings":"AACA,mCACE,yBAA0B,AAC1B,qBAA0B,CAC3B,AACD,iCACE,cAAe,AACf,iBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,yBACA,iCACM,cAAgB,CACrB,CACA,AACD,iCACE,sBAA0B,AAC1B,wCAA6C,AAC7C,mBAAoB,AACpB,iBAAmB,CACpB,AACD,yBACA,iCACM,iBAAmB,CACxB,CACA,AACD,yBACE,yBAA0B,AAC1B,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,UAAY,CACb,AACD,uBACE,cAAe,AACf,eAAgB,AAChB,gBAAkB,CACnB,AACD,yBACA,uBACM,cAAgB,CACrB,CACA,AACD,2BACE,cAAe,AACf,cAAgB,CACjB,AACD,yBACA,2BACM,cAAgB,CACrB,CACA,AACD,0BACE,kBAAoB,CACrB,AACD,wBACE,kBAAoB,CACrB,AACD,yBACA,wBACM,eAAiB,CACtB,CACA,AACD,wBACE,iBAAmB,CACpB,AACD,yBACA,wBACM,cAAgB,CACrB,CACA,AACD,yBACA,wBACI,WAAa,CAChB,CACA,AACD,4BACE,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB","file":"section-benefits.vue","sourcesContent":["\n.section-benefits[data-v-491abc2b] {\n  background-color: #fafafa;\n  padding: 81px 7% 102px 7%;\n}\n.benefits-title[data-v-491abc2b] {\n  color: #085f65;\n  font-family: \"Lato\";\n  font-size: 30px;\n  font-weight: 900;\n  margin-bottom: 50px;\n  text-align: center;\n}\n@media (max-width: 936px) {\n.benefits-title[data-v-491abc2b] {\n      font-size: 24px;\n}\n}\n.wrapper-points[data-v-491abc2b] {\n  background-color: #ffffff;\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.06);\n  border-radius: 20px;\n  padding: 83px 70px;\n}\n@media (max-width: 936px) {\n.wrapper-points[data-v-491abc2b] {\n      padding: 47px 20px;\n}\n}\n.number[data-v-491abc2b] {\n  background-color: #b1dc03;\n  border-radius: 50%;\n  color: #02979b;\n  font-size: 18px;\n  font-weight: 600;\n  height: 34px;\n  padding-top: 4px;\n  text-align: center;\n  width: 34px;\n}\n.text[data-v-491abc2b] {\n  color: #8f8f8f;\n  font-size: 20px;\n  line-height: 25px;\n}\n@media (max-width: 936px) {\n.text[data-v-491abc2b] {\n      font-size: 16px;\n}\n}\n.sub-text[data-v-491abc2b] {\n  color: #8f8f8f;\n  font-size: 18px;\n}\n@media (max-width: 936px) {\n.sub-text[data-v-491abc2b] {\n      font-size: 16px;\n}\n}\n.mb-text[data-v-491abc2b] {\n  margin-bottom: 16px;\n}\n.pr-48[data-v-491abc2b] {\n  padding-right: 48px;\n}\n@media (max-width: 936px) {\n.pr-48[data-v-491abc2b] {\n      padding-right: 0;\n}\n}\n.pl-48[data-v-491abc2b] {\n  padding-left: 48px;\n}\n@media (max-width: 936px) {\n.pl-48[data-v-491abc2b] {\n      padding-left: 0;\n}\n}\n@media (max-width: 936px) {\n.check[data-v-491abc2b] {\n    height: 22px;\n}\n}\n.href-here[data-v-491abc2b] {\n  color: #02979b;\n  font-size: 20px;\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-benefits"},[_c('p',{staticClass:"benefits-title"},[_vm._v("SÉ PARTE DE NUESTRA RED DE BODEGUEROS AFILIADOS")]),_vm._v(" "),_c('v-layout',{staticClass:"wrapper-points container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pr-48",attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"number"},[_vm._v("1")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-3":""}},[_c('p',{staticClass:"mb-0 text"},[_vm._v("Tus clientes se descargarán tu APP de Google play.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"number"},[_vm._v("2")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-3":""}},[_c('p',{staticClass:"mb-0 text"},[_vm._v("Tendrás tu usuario y contraseña secreta  para que puedas ingresar al administrador web.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"number"},[_vm._v("3")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-3":""}},[_c('p',{staticClass:"mb-0 text"},[_vm._v("Podrás realizar dos tipos de entrega: El recojo en tienda y la entrega de pedidos a domicilio (delivery).")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"number"},[_vm._v("4")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-3":""}},[_c('p',{staticClass:"mb-0 text"},[_vm._v("Podrás administrar todo desde tu computadora o celular.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"number"},[_vm._v("5")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-3":""}},[_c('p',{staticClass:"mb-0 text"},[_vm._v("Gestionar tus productos, cambiar precios, agregar un nuevo producto o modificarlo.")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-48",attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"number"},[_vm._v("6")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-3":""}},[_c('p',{staticClass:"mb-4 text"},[_vm._v("El servicio de implementación incluye:")]),_vm._v(" "),_c('div',[_c('v-layout',{staticClass:"mb-text"},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',[_c('img',{staticClass:"check",attrs:{"src":"https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png","alt":"check"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-2":""}},[_c('p',{staticClass:"mb-0 sub-text"},[_vm._v("3 horas de soporte por voz")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-text"},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',[_c('img',{staticClass:"check",attrs:{"src":"https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png","alt":"check"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-2":""}},[_c('p',{staticClass:"mb-0 sub-text"},[_vm._v("La carga de la base de datos de tus productos a la plataforma.")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-text"},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',[_c('img',{staticClass:"check",attrs:{"src":"https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png","alt":"check"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-2":""}},[_c('p',{staticClass:"mb-0 sub-text"},[_vm._v("Soporte por correo ilimitado.")])])],1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',{staticClass:"number"},[_vm._v("7")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-3":""}},[_c('p',{staticClass:"mb-4 text"},[_vm._v("\n\t\t\t\t\t\tAcceder a nuestra promoción desde "),_c('a',{staticClass:"href-here",attrs:{"href":_vm.hrefHere,"target":"_blank"}},[_vm._v("aquí")]),_vm._v(" (en caso apliques):\n\t\t\t\t\t")]),_vm._v(" "),_c('div',[_c('v-layout',{staticClass:"mb-text"},[_c('v-flex',{attrs:{"xs1":""}},[_c('div',[_c('img',{staticClass:"check",attrs:{"src":"https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png","alt":"check"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-2":""}},[_c('p',{staticClass:"mb-0 sub-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.creditQuantity)+" pedicréditos en pedidos = "+_vm._s(_vm.creditQuantity)+" pedidos sin costo = "+_vm._s(_vm.currencySymbol)+_vm._s(_vm._f("round")(_vm.creditTotal))+" de regalo\n\t\t\t\t\t\t\t\t")])])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs1":""}},[_c('div',[_c('img',{staticClass:"check",attrs:{"src":"https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png","alt":"check"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pl-2":""}},[_c('p',{staticClass:"mb-0 sub-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t1 pedicrédito = "+_vm._s(_vm.currencySymbol)+_vm._s(_vm._f("round")(_vm.creditValue))+" pedido através de aplicativo.\n\t\t\t\t\t\t\t\t")])])],1)],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_question_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f55aee6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_question_vue__ = __webpack_require__(684);
function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f55aee6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f55aee6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(683);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("6b8cd9fa", content, true, {});

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-question[data-v-f55aee6e]{padding:75px 7% 25px}@media (max-width:936px){.section-question[data-v-f55aee6e]{padding:30px 0}}.title[data-v-f55aee6e]{color:#085f65;font-size:30px!important;font-weight:900!important;margin-bottom:60px!important;padding-top:15px}@media (max-width:936px){.title[data-v-f55aee6e]{font-size:24px!important;margin-bottom:30px!important;text-align:center}}.section-title[data-v-f55aee6e]{background-color:#f2f6f7;color:#085f65;font-weight:600;padding:8px 12px}@media (max-width:936px){.section-title[data-v-f55aee6e]{text-align:center}}.section-text[data-v-f55aee6e]{color:#8f8f8f;font-size:14px;margin-bottom:10px;margin-left:11px}@media (max-width:936px){.section-text[data-v-f55aee6e]{margin-bottom:10px;min-height:auto;text-align:center}}@media (max-width:936px){.wrapper-logo[data-v-f55aee6e]{text-align:center}}.pr-24[data-v-f55aee6e]{padding-right:24px}@media (max-width:936px){.pr-24[data-v-f55aee6e]{padding-right:0}}.pl-24[data-v-f55aee6e]{padding-left:24px}@media (max-width:936px){.pl-24[data-v-f55aee6e]{padding-left:0}}.href-here[data-v-f55aee6e]{color:#02979b;font-size:14px;font-weight:700}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/section-question.vue"],"names":[],"mappings":"AACA,mCACE,oBAAyB,CAC1B,AACD,yBACA,mCACM,cAAgB,CACrB,CACA,AACD,wBACE,cAAe,AACf,yBAA2B,AAC3B,0BAA4B,AAC5B,6BAA+B,AAC/B,gBAAkB,CACnB,AACD,yBACA,wBACM,yBAA2B,AAC3B,6BAA+B,AAC/B,iBAAmB,CACxB,CACA,AACD,gCACE,yBAA0B,AAC1B,cAAe,AACf,gBAAiB,AACjB,gBAAkB,CACnB,AACD,yBACA,gCACM,iBAAmB,CACxB,CACA,AACD,+BACE,cAAe,AACf,eAAgB,AAChB,mBAAoB,AACpB,gBAAkB,CACnB,AACD,yBACA,+BACM,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACxB,CACA,AACD,yBACA,+BACI,iBAAmB,CACtB,CACA,AACD,wBACE,kBAAoB,CACrB,AACD,yBACA,wBACM,eAAiB,CACtB,CACA,AACD,wBACE,iBAAmB,CACpB,AACD,yBACA,wBACM,cAAgB,CACrB,CACA,AACD,4BACE,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB","file":"section-question.vue","sourcesContent":["\n.section-question[data-v-f55aee6e] {\n  padding: 75px 7% 25px 7%;\n}\n@media (max-width: 936px) {\n.section-question[data-v-f55aee6e] {\n      padding: 30px 0;\n}\n}\n.title[data-v-f55aee6e] {\n  color: #085f65;\n  font-size: 30px !important;\n  font-weight: 900 !important;\n  margin-bottom: 60px !important;\n  padding-top: 15px;\n}\n@media (max-width: 936px) {\n.title[data-v-f55aee6e] {\n      font-size: 24px !important;\n      margin-bottom: 30px !important;\n      text-align: center;\n}\n}\n.section-title[data-v-f55aee6e] {\n  background-color: #f2f6f7;\n  color: #085f65;\n  font-weight: 600;\n  padding: 8px 12px;\n}\n@media (max-width: 936px) {\n.section-title[data-v-f55aee6e] {\n      text-align: center;\n}\n}\n.section-text[data-v-f55aee6e] {\n  color: #8f8f8f;\n  font-size: 14px;\n  margin-bottom: 10px;\n  margin-left: 11px;\n}\n@media (max-width: 936px) {\n.section-text[data-v-f55aee6e] {\n      margin-bottom: 10px;\n      min-height: auto;\n      text-align: center;\n}\n}\n@media (max-width: 936px) {\n.wrapper-logo[data-v-f55aee6e] {\n    text-align: center;\n}\n}\n.pr-24[data-v-f55aee6e] {\n  padding-right: 24px;\n}\n@media (max-width: 936px) {\n.pr-24[data-v-f55aee6e] {\n      padding-right: 0;\n}\n}\n.pl-24[data-v-f55aee6e] {\n  padding-left: 24px;\n}\n@media (max-width: 936px) {\n.pl-24[data-v-f55aee6e] {\n      padding-left: 0;\n}\n}\n.href-here[data-v-f55aee6e] {\n  color: #02979b;\n  font-size: 14px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-question"},[_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"wrapper-logo",attrs:{"xs12":"","md1":""}},[_c('img',{attrs:{"src":(_vm.$S3 + "logo-min.svg"),"alt":"logo","height":"58"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('p',{staticClass:"mb-0 title"},[_vm._v("PREGUNTAS FRECUENTES")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pr-24",attrs:{"xs12":"","md5":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿Cuál es el costo de tener mi propio Aplicativo?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tTener tu propia app de pedidos con una mínima inversión.\n\t\t\t\tDéjanos tus datos "),_c('a',{staticClass:"href-here",attrs:{"href":_vm.hrefHere}},[_vm._v("aquí")]),_vm._v(" para que un asesor de ventas se comunique\n\t\t\t\tcontigo y pueda darte todo el detalle del servicio.\n\t\t\t")])]),_vm._v(" "),_c('v-flex',{staticClass:"pl-24",attrs:{"xs12":"","md7":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿Qué puedo vender con MiBodega?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tPuedes vender lo que quieras en el rubro que desees, recuerda que es tu negocio y hemos creado un aplicativo\n\t\t\t\tque se adapta a ti.\n\t\t\t")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pr-24",attrs:{"xs12":"","md5":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿El servicio es a nivel nacional?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tSi, puedes contratar nuestro servicio a nivel nacional.\n\t\t\t\tMiBodega funciona en todo el país.\n\t\t\t")])]),_vm._v(" "),_c('v-flex',{staticClass:"pl-24",attrs:{"xs12":"","md7":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿Qué pasa si no cuente con el servicio de delivery?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tNo hay problema, MiBodega se adapta a tu negocio y solo ofrecerás el servicio de \"pago en efectivo\".\n\t\t\t\tEn el momento que decías incluir el servicio de pago online lo incluimos en tu aplicativo, ya que estamos\n\t\t\t\tpreparados para ofrecerlo. El contrato con las plataformas de pago online es directamente con el dueño del negocio.\n\t\t\t")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pr-24",attrs:{"xs12":"","md5":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿Qué pasa si tengo más de un local?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tExcelente, con MiBodega puedes gestionar todas los negocios que tengas.\n\t\t\t\tDéjanos tus datos "),_c('a',{staticClass:"href-here",attrs:{"href":_vm.hrefHere}},[_vm._v("aquí")]),_vm._v(" para que\n\t\t\t\tun asesor de ventas se comunique contigo y pueda darte todo el detalle del servicio.\n\t\t\t")])]),_vm._v(" "),_c('v-flex',{staticClass:"pl-24",attrs:{"xs12":"","md7":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿Qué pasa si no cuento con el servicio de pago online?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tNo hay problema, MiBodega se adapta a tu negocio y solo ofrecerás el servicio de \"pago en efectivo\".\n\t\t\t\tEn el momento que decías incluir el servicio de pago online lo incluimos en tu aplicativo, ya que\n\t\t\t\testamos preparados para ofrecerlo. El contrato con las plataformas de pago online es directamente\n\t\t\t\tcon el dueño del negocio.\n\t\t\t")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pr-24",attrs:{"xs12":"","md5":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿En cuánto tiempo me entregan el aplicativo?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tDepende cuán rápido efectúes el pago y coordinemos toda la información de tu negocio,\n\t\t\t\tpero es un promedio de 2 semanas como máximo.\n\t\t\t")])]),_vm._v(" "),_c('v-flex',{staticClass:"pl-24",attrs:{"xs12":"","md7":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿Cómo funcionan los Pedicréditos?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tEs muy sencillo y hemos pensado la manera más conveniente para negocio.\n\t\t\t\tSólo debes precargar tu aplicativo con el monto que deseas y este se descontará\n\t\t\t\tde cada pedido generado. Por ejemplo, si recargas "+_vm._s(_vm.currencySymbol)+_vm._s(_vm.creditValue)+"\n\t\t\t\tde \"Pedicréditos\" ese dinero te alcanza para la comisión de 5 pedidos de\n\t\t\t\t"+_vm._s(_vm.currencySymbol)+_vm._s(_vm._f("round")(_vm.fiveOrders))+" "+_vm._s(_vm.centLabel)+" cada uno. En el caso que no hayas\n\t\t\t\thecho la recarga de \"Pedicréditos\" y un cliente haga un pedido, te avisamos para que recargues\n\t\t\t\ty no pierdas la venta. El monto mínimo de recarga es de "+_vm._s(_vm.currencySymbol)+_vm._s(_vm.minValue)+".\n\t\t\t")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"container",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pr-24",attrs:{"xs12":"","md5":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿Quién determina el precio del producto?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tTú, como dueño de tu negocio. Es muy sencillo de hacerlo: Ingresando a tu administrador\n\t\t\t\tpodrás ingresar los precios de tus productos y definir los precios de los mismos.\n\t\t\t")])]),_vm._v(" "),_c('v-flex',{staticClass:"pl-24",attrs:{"xs12":"","md7":""}},[_c('div',{staticClass:"section-title"},[_vm._v("\n\t\t\t\t¿MiBodega trabaja con otro tipo de negocios, como restaurantes o lavanderías?\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_vm._v("\n\t\t\t\tSi, ponemos a disposición de otras industrias el aplicativo para que puedan hacer crecer su negocio.\n\t\t\t\tEn caso desees más información, déjanos tus datos "),_c('a',{staticClass:"href-here",attrs:{"href":_vm.hrefHere}},[_vm._v("aquí")]),_vm._v(" para\n\t\t\t\tque un asesor de ventas se comunique contigo y pueda darte todo el detalle del servicio.\n\t\t\t")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_header_vue__ = __webpack_require__(579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d96f184_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_header_vue__ = __webpack_require__(688);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d96f184"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d96f184_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(687);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("4525d520", content, true, {});

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".section-header[data-v-1d96f184]{background:#fff;box-shadow:0 0 11px 0 rgba(0,0,0,.09);padding:10px 7%;position:fixed;top:-100px;transition:all .5s ease;width:100%;z-index:999}.section-header.scrolling[data-v-1d96f184]{top:68px}.section-header.scrolling.no-banner[data-v-1d96f184]{top:0}@media (max-width:830px){.section-header[data-v-1d96f184]{padding:10px;top:-105px}.section-header.scrolling[data-v-1d96f184]{top:123px}.section-header.scrolling.no-banner[data-v-1d96f184]{top:0}}.btn-link[data-v-1d96f184]{background-color:#02979b;border-radius:7px;color:#fff;display:inline-block;font-size:13px;margin-right:13px;padding:8px 4px;text-align:center;text-decoration:none}@media (max-width:830px){.btn-link[data-v-1d96f184]{margin-right:3px}}.pat-5[data-v-1d96f184]{padding-top:5px}.wrapper-buttons[data-v-1d96f184]{display:flex;justify-content:flex-end}@media (max-width:830px){.wrapper-buttons[data-v-1d96f184]{justify-content:space-around}}.btn-app[data-v-1d96f184]{opacity:0;transition:all .3s ease}.btn-app.scrolling[data-v-1d96f184]{opacity:1}@media (max-width:830px){.desktop[data-v-1d96f184]{display:none}}.mobile[data-v-1d96f184]{display:none}@media (max-width:830px){.mobile[data-v-1d96f184]{display:block}}.disabled-btn[data-v-1d96f184]{background-color:#fff;border-radius:7px;bottom:0;cursor:not-allowed;left:0;opacity:.5;position:absolute;right:0;top:0}.wrapper-link[data-v-1d96f184]{position:relative}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/section-header.vue"],"names":[],"mappings":"AACA,iCACE,gBAAoB,AACpB,sCAA2C,AAC3C,gBAAiB,AACjB,eAAgB,AAChB,WAAY,AACZ,wBAA0B,AAC1B,WAAY,AACZ,WAAa,CACd,AACD,2CACI,QAAU,CACb,AACD,qDACM,KAAS,CACd,AACD,yBACA,iCACM,aAAc,AACd,UAAY,CACjB,AACD,2CACQ,SAAW,CAClB,AACD,qDACU,KAAS,CAClB,CACA,AACD,2BACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,kBAAmB,AACnB,oBAAsB,CACvB,AACD,yBACA,2BACM,gBAAkB,CACvB,CACA,AACD,wBACE,eAAiB,CAClB,AACD,kCACE,aAAc,AACd,wBAA0B,CAC3B,AACD,yBACA,kCACM,4BAA8B,CACnC,CACA,AACD,0BACE,UAAW,AACX,uBAA0B,CAC3B,AACD,oCACI,SAAW,CACd,AACD,yBACA,0BACI,YAAc,CACjB,CACA,AACD,yBACE,YAAc,CACf,AACD,yBACA,yBACM,aAAe,CACpB,CACA,AACD,+BACE,sBAA0B,AAC1B,kBAAmB,AACnB,SAAU,AACV,mBAAoB,AACpB,OAAQ,AACR,WAAa,AACb,kBAAmB,AACnB,QAAS,AACT,KAAO,CACR,AACD,+BACE,iBAAmB,CACpB","file":"section-header.vue","sourcesContent":["\n.section-header[data-v-1d96f184] {\n  background: #ffffff;\n  box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.09);\n  padding: 10px 7%;\n  position: fixed;\n  top: -100px;\n  transition: all 0.5s ease;\n  width: 100%;\n  z-index: 999;\n}\n.section-header.scrolling[data-v-1d96f184] {\n    top: 68px;\n}\n.section-header.scrolling.no-banner[data-v-1d96f184] {\n      top: 0px;\n}\n@media (max-width: 830px) {\n.section-header[data-v-1d96f184] {\n      padding: 10px;\n      top: -105px;\n}\n.section-header.scrolling[data-v-1d96f184] {\n        top: 123px;\n}\n.section-header.scrolling.no-banner[data-v-1d96f184] {\n          top: 0px;\n}\n}\n.btn-link[data-v-1d96f184] {\n  background-color: #02979b;\n  border-radius: 7px;\n  color: #ffffff;\n  display: inline-block;\n  font-size: 13px;\n  margin-right: 13px;\n  padding: 8px 4px;\n  text-align: center;\n  text-decoration: none;\n}\n@media (max-width: 830px) {\n.btn-link[data-v-1d96f184] {\n      margin-right: 3px;\n}\n}\n.pat-5[data-v-1d96f184] {\n  padding-top: 5px;\n}\n.wrapper-buttons[data-v-1d96f184] {\n  display: flex;\n  justify-content: flex-end;\n}\n@media (max-width: 830px) {\n.wrapper-buttons[data-v-1d96f184] {\n      justify-content: space-around;\n}\n}\n.btn-app[data-v-1d96f184] {\n  opacity: 0;\n  transition: all 0.3s ease;\n}\n.btn-app.scrolling[data-v-1d96f184] {\n    opacity: 1;\n}\n@media (max-width: 830px) {\n.desktop[data-v-1d96f184] {\n    display: none;\n}\n}\n.mobile[data-v-1d96f184] {\n  display: none;\n}\n@media (max-width: 830px) {\n.mobile[data-v-1d96f184] {\n      display: block;\n}\n}\n.disabled-btn[data-v-1d96f184] {\n  background-color: #ffffff;\n  border-radius: 7px;\n  bottom: 0;\n  cursor: not-allowed;\n  left: 0;\n  opacity: 0.5;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.wrapper-link[data-v-1d96f184] {\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-header",class:{ 'scrolling': _vm.scrolled, 'no-banner': !_vm.bannerVisible }},[_c('v-flex',{staticClass:"container",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md7":"","xs2":""}},[_c('img',{staticClass:"desktop",attrs:{"src":(_vm.$S3 + "logo-text-green.svg"),"alt":"logo","height":"30"}}),_vm._v(" "),_c('img',{staticClass:"mobile",attrs:{"src":(_vm.$S3 + "logo-min.svg"),"height":"37","alt":"logo"}})]),_vm._v(" "),_c('v-flex',{attrs:{"md5":"","xs10":""}},[_c('div',{staticClass:"wrapper-buttons"},[_c('div',{staticClass:"pat-5 btn-app",class:{scrolling: _vm.scrollingOne}},[_c('div',{staticClass:"wrapper-link"},[(_vm.disabledRegisterApp)?_c('div',{staticClass:"disabled-btn"}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn-link",attrs:{"href":_vm.disabledRegisterApp ? '#' : '#generate-app'}},[_vm._v("ACTIVA TU APP")])])]),_vm._v(" "),_c('div',{staticClass:"pat-5"},[_c('div',{staticClass:"wrapper-link"},[(_vm.disabledPayment)?_c('div',{staticClass:"disabled-btn"}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn-link",attrs:{"href":_vm.disabledPayment ? '#' : _vm.linkPayment,"target":"_blank"}},[_vm._v("REALIZAR PAGO")])])]),_vm._v(" "),_c('div',{staticClass:"desktop",attrs:{"xs4":""}},[_c('div',[_c('a',{attrs:{"href":_vm.linkGooglePlay,"target":"_blank"}},[_c('img',{attrs:{"src":(_vm.$S3 + "icon-google.png"),"alt":"google play","height":"47"}})])])])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_invalid_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaf3eeee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_invalid_vue__ = __webpack_require__(693);
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_invalid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaf3eeee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_invalid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(379)("3190429d", content, true, {});

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(378)(true);
// imports


// module
exports.push([module.i, ".text-message[data-v-5a96e38a]{color:#d5331a;font-size:37px;font-weight:600;margin-bottom:80px;text-align:center}.center[data-v-5a96e38a]{text-align:center}.btn-link[data-v-5a96e38a]{background:#b1dc03;border-radius:7px;color:#02979b;display:inline-block;font-size:23px;font-weight:600;padding:10px 20px;text-decoration:none}.section-information[data-v-5a96e38a]{padding:100px 0}.text-message-down[data-v-5a96e38a]{color:#00888c;font-size:28px;text-align:center}", "", {"version":3,"sources":["/opt/build/repo/src/components/generate-app/section-information.vue"],"names":[],"mappings":"AACA,+BACE,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,yBACE,iBAAmB,CACpB,AACD,2BACE,mBAAoB,AACpB,kBAAmB,AACnB,cAAe,AACf,qBAAsB,AACtB,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,oBAAsB,CACvB,AACD,sCACE,eAAiB,CAClB,AACD,oCACE,cAAe,AACf,eAAgB,AAChB,iBAAmB,CACpB","file":"section-information.vue","sourcesContent":["\n.text-message[data-v-5a96e38a] {\n  color: #d5331a;\n  font-size: 37px;\n  font-weight: 600;\n  margin-bottom: 80px;\n  text-align: center;\n}\n.center[data-v-5a96e38a] {\n  text-align: center;\n}\n.btn-link[data-v-5a96e38a] {\n  background: #b1dc03;\n  border-radius: 7px;\n  color: #02979b;\n  display: inline-block;\n  font-size: 23px;\n  font-weight: 600;\n  padding: 10px 20px;\n  text-decoration: none;\n}\n.section-information[data-v-5a96e38a] {\n  padding: 100px 0;\n}\n.text-message-down[data-v-5a96e38a] {\n  color: #00888c;\n  font-size: 28px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"section-information",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"center",attrs:{"xs12":"","mb-3":""}},[_c('img',{attrs:{"src":"/static/images/banners/error.svg","alt":"error","height":"89"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"text-message"},[_vm._v(_vm._s(_vm.message))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"text-message-down mb-5"},[_vm._v(_vm._s(_vm.messageDown)+" ")])]),_vm._v(" "),(_vm.invalid)?_c('v-flex',{staticClass:"center",attrs:{"xs12":""}},[_c('p',{staticClass:"btn-link"},[_vm._v("mibodega@makipos.la")])]):_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"justify-center":""}},_vm._l((_vm.contacts),function(contact,index){return _c('v-flex',{key:index,staticClass:"center",attrs:{"xs4":""}},[_c('a',{staticClass:"btn-link",attrs:{"href":_vm.wspContact(contact),"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images/banners/whatsapp-green.svg","alt":"whatsapp"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(contact.name))])])])}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-pago'),_vm._v(" "),_c('section-information',{attrs:{"message":"TOKEN INVALIDO","message-down":"Escribenos a:","invalid":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_expired_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03661b85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_expired_vue__ = __webpack_require__(695);
var normalizeComponent = __webpack_require__(130)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_section_expired_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03661b85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_section_expired_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-pago'),_vm._v(" "),_c('section-information',{attrs:{"message":"TU TOKEN CADUCO","message-down":"Comunicate con cualquiera de nuestros asesores de venta: "}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showInvalid)?_c('section-invalid'):(_vm.showExpired)?_c('section-expired'):_c('div',[_c('banner-top',{attrs:{"configuration":_vm.configuration},on:{"get-banner-value":_vm.getBannerValue}}),_vm._v(" "),_c('section-header',{attrs:{"banner-visible":_vm.bannerVisible,"disabled-register-app":_vm.disabledRegisterApp,"disabled-payment":_vm.disabledPayment}}),_vm._v(" "),_c('banner',{attrs:{"banner-visible":_vm.bannerVisible,"disabled-register-app":_vm.disabledRegisterApp,"disabled-payment":_vm.disabledPayment}}),_vm._v(" "),_c('section-generate-app',{attrs:{"disabled-register-app":_vm.disabledRegisterApp,"token":_vm.token,"departaments":_vm.departaments}}),_vm._v(" "),_c('section-benefits'),_vm._v(" "),_c('section-question')],1),_vm._v(" "),_c('new-footer',{attrs:{"gray":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]));


// WEBPACK FOOTER //
// static/js/1.5eb3088d1878c64c4764.js